/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as SelectWorkspaceRouteImport } from './routes/select-workspace'
import { Route as VersionRouteImport } from './routes/version'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugAppsRouteImport } from './routes/$slug/apps'
import { Route as SlugDepartmentRouteImport } from './routes/$slug/department'
import { Route as SlugInitialSetupRouteImport } from './routes/$slug/initial-setup'
import { Route as SlugMyTasksRouteImport } from './routes/$slug/my-tasks'
import { Route as SlugOmniscientRouteImport } from './routes/$slug/omniscient'
import { Route as SlugOrganizationRouteImport } from './routes/$slug/organization'
import { Route as SlugOrganizationSettingsRouteImport } from './routes/$slug/organization-settings'
import { Route as SlugSeatOverrunRouteImport } from './routes/$slug/seat-overrun'
import { Route as SlugSetupPendingRouteImport } from './routes/$slug/setup-pending'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as PartnerIndexRouteImport } from './routes/partner/index'
import { Route as PartnerAppsRouteImport } from './routes/partner/apps'
import { Route as PartnerTasksRouteImport } from './routes/partner/tasks'
import { Route as SlugAppsSplatRouteImport } from './routes/$slug/apps/$'
import { Route as SlugArtifactsArtifactIdRouteImport } from './routes/$slug/artifacts/$artifactId'
import { Route as SlugDepartmentIndexRouteImport } from './routes/$slug/department/index'
import { Route as SlugDepartmentMembersRouteImport } from './routes/$slug/department/members'
import { Route as SlugDepartmentsDepartmentIdRouteImport } from './routes/$slug/departments/$departmentId'
import { Route as SlugExternalContactsExternalContactIdRouteImport } from './routes/$slug/external-contacts/$externalContactId'
import { Route as SlugHelpIndexRouteImport } from './routes/$slug/help/index'
import { Route as SlugMyTasksIndexRouteImport } from './routes/$slug/my-tasks/index'
import { Route as SlugOmniscientIndexRouteImport } from './routes/$slug/omniscient/index'
import { Route as SlugOmniscientSessionIdRouteImport } from './routes/$slug/omniscient/$sessionId'
import { Route as SlugOrgFunctionsIndexRouteImport } from './routes/$slug/org-functions/index'
import { Route as SlugOrgMembersOrgMemberIdRouteImport } from './routes/$slug/org-members/$orgMemberId'
import { Route as SlugOrganigramIndexRouteImport } from './routes/$slug/organigram/index'
import { Route as SlugOrganizationSettingsIndexRouteImport } from './routes/$slug/organization-settings/index'
import { Route as SlugOrganizationSettingsAppsRouteImport } from './routes/$slug/organization-settings/apps'
import { Route as SlugOrganizationSettingsDataSyncRouteImport } from './routes/$slug/organization-settings/data-sync'
import { Route as SlugOrganizationSettingsSettingsRouteImport } from './routes/$slug/organization-settings/settings'
import { Route as SlugOrganizationSettingsUserManagementRouteImport } from './routes/$slug/organization-settings/user-management'
import { Route as SlugOrganizationArtifactsRouteImport } from './routes/$slug/organization/artifacts'
import { Route as SlugOrganizationDepartmentsRouteImport } from './routes/$slug/organization/departments'
import { Route as SlugOrganizationExternalContactsRouteImport } from './routes/$slug/organization/external-contacts'
import { Route as SlugOrganizationFunctionsRouteImport } from './routes/$slug/organization/functions'
import { Route as SlugOrganizationOrgMembersRouteImport } from './routes/$slug/organization/org-members'
import { Route as SlugOrganizationSystemsRouteImport } from './routes/$slug/organization/systems'
import { Route as SlugOrganizationTeamsRouteImport } from './routes/$slug/organization/teams'
import { Route as SlugProcessesAllProcessesRouteImport } from './routes/$slug/processes/all-processes'
import { Route as SlugProcessesCreateProcessesRouteImport } from './routes/$slug/processes/create-processes'
import { Route as SlugProcessesProcessChainsRouteImport } from './routes/$slug/processes/process-chains'
import { Route as SlugProcessesProcessMapRouteImport } from './routes/$slug/processes/process-map'
import { Route as SlugRecordingDashboardIndexRouteImport } from './routes/$slug/recording-dashboard/index'
import { Route as SlugSystemsIndexRouteImport } from './routes/$slug/systems/index'
import { Route as SlugSystemsSystemIdRouteImport } from './routes/$slug/systems/$systemId'
import { Route as SlugSystemsLandscapeRouteImport } from './routes/$slug/systems/landscape'
import { Route as SlugSystemsShadowSystemsRouteImport } from './routes/$slug/systems/shadow-systems'
import { Route as AdminAccountsIndexRouteImport } from './routes/admin/accounts/index'
import { Route as AdminAiUsageIndexRouteImport } from './routes/admin/ai-usage/index'
import { Route as AdminAnalyticsIndexRouteImport } from './routes/admin/analytics/index'
import { Route as AdminAuditLogsIndexRouteImport } from './routes/admin/audit-logs/index'
import { Route as AdminPartnerContentIndexRouteImport } from './routes/admin/partner-content/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminTenantsIndexRouteImport } from './routes/admin/tenants/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as PartnerAppsSplatRouteImport } from './routes/partner/apps/$'
import { Route as PartnerOrganizationIndexRouteImport } from './routes/partner/organization/index'
import { Route as PartnerOrganizationUsersRouteImport } from './routes/partner/organization/users'
import { Route as SlugDepartmentMembersIndexRouteImport } from './routes/$slug/department/members/index'
import { Route as SlugDepartmentTeamsIndexRouteImport } from './routes/$slug/department/teams/index'
import { Route as SlugHelpTicketsIndexRouteImport } from './routes/$slug/help/tickets/index'
import { Route as SlugOrganizationArtifactsIndexRouteImport } from './routes/$slug/organization/artifacts/index'
import { Route as SlugOrganizationArtifactsArtifactIdRouteImport } from './routes/$slug/organization/artifacts/$artifactId'
import { Route as SlugOrganizationDepartmentsIndexRouteImport } from './routes/$slug/organization/departments/index'
import { Route as SlugOrganizationDepartmentsDepartmentIdRouteImport } from './routes/$slug/organization/departments/$departmentId'
import { Route as SlugOrganizationDepartmentsBulkUploadRouteImport } from './routes/$slug/organization/departments/bulk-upload'
import { Route as SlugOrganizationExternalContactsIndexRouteImport } from './routes/$slug/organization/external-contacts/index'
import { Route as SlugOrganizationExternalContactsExternalContactIdRouteImport } from './routes/$slug/organization/external-contacts/$externalContactId'
import { Route as SlugOrganizationFunctionsIndexRouteImport } from './routes/$slug/organization/functions/index'
import { Route as SlugOrganizationFunctionsOrgFunctionIdRouteImport } from './routes/$slug/organization/functions/$orgFunctionId'
import { Route as SlugOrganizationOrgMembersIndexRouteImport } from './routes/$slug/organization/org-members/index'
import { Route as SlugOrganizationOrgMembersOrgMemberIdRouteImport } from './routes/$slug/organization/org-members/$orgMemberId'
import { Route as SlugOrganizationSystemsIndexRouteImport } from './routes/$slug/organization/systems/index'
import { Route as SlugOrganizationSystemsSystemIdRouteImport } from './routes/$slug/organization/systems/$systemId'
import { Route as SlugOrganizationTeamsIndexRouteImport } from './routes/$slug/organization/teams/index'
import { Route as SlugOrganizationTeamsOrgFunctionIdRouteImport } from './routes/$slug/organization/teams/$orgFunctionId'
import { Route as SlugProcessesAllProcessesIndexRouteImport } from './routes/$slug/processes/all-processes/index'
import { Route as SlugProcessesAllProcessesProcessIdRouteImport } from './routes/$slug/processes/all-processes/$processId'
import { Route as SlugProcessesCreateProcessesIndexRouteImport } from './routes/$slug/processes/create-processes/index'
import { Route as SlugProcessesEditorIndexRouteImport } from './routes/$slug/processes/editor/index'
import { Route as SlugProcessesEditorProcessIdRouteImport } from './routes/$slug/processes/editor/$processId'
import { Route as SlugProcessesProcessChainsIndexRouteImport } from './routes/$slug/processes/process-chains/index'
import { Route as SlugProcessesProcessChainsChainIdRouteImport } from './routes/$slug/processes/process-chains/$chainId'
import { Route as AdminAccountsAccountIdIndexRouteImport } from './routes/admin/accounts/$accountId/index'
import { Route as AdminTenantsTenantIdIndexRouteImport } from './routes/admin/tenants/$tenantId/index'
import { Route as SlugHelpTicketsTicketIdIndexRouteImport } from './routes/$slug/help/tickets/$ticketId/index'
import { Route as SlugProcessesAllProcessesProcessIdIndexRouteImport } from './routes/$slug/processes/all-processes/$processId.index'
import { Route as SlugProcessesAllProcessesProcessIdFlowFullscreenRouteImport } from './routes/$slug/processes/all-processes/$processId.flow-fullscreen'
import { Route as SlugProcessesRecordingStartRecordingProcessIdRouteImport } from './routes/$slug/processes/recording/start-recording/$processId'
import { Route as SlugProcessesRecordingStepRecordingRecordingIdRouteImport } from './routes/$slug/processes/recording/step-recording/$recordingId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRoute = PartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectWorkspaceRoute = SelectWorkspaceRouteImport.update({
  id: '/select-workspace',
  path: '/select-workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const VersionRoute = VersionRouteImport.update({
  id: '/version',
  path: '/version',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugIndexRoute = SlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugAppsRoute = SlugAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => SlugRoute,
} as any)
const SlugDepartmentRoute = SlugDepartmentRouteImport.update({
  id: '/department',
  path: '/department',
  getParentRoute: () => SlugRoute,
} as any)
const SlugInitialSetupRoute = SlugInitialSetupRouteImport.update({
  id: '/initial-setup',
  path: '/initial-setup',
  getParentRoute: () => SlugRoute,
} as any)
const SlugMyTasksRoute = SlugMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOmniscientRoute = SlugOmniscientRouteImport.update({
  id: '/omniscient',
  path: '/omniscient',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOrganizationRoute = SlugOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOrganizationSettingsRoute =
  SlugOrganizationSettingsRouteImport.update({
    id: '/organization-settings',
    path: '/organization-settings',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugSeatOverrunRoute = SlugSeatOverrunRouteImport.update({
  id: '/seat-overrun',
  path: '/seat-overrun',
  getParentRoute: () => SlugRoute,
} as any)
const SlugSetupPendingRoute = SlugSetupPendingRouteImport.update({
  id: '/setup-pending',
  path: '/setup-pending',
  getParentRoute: () => SlugRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerIndexRoute = PartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartnerRoute,
} as any)
const PartnerAppsRoute = PartnerAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => PartnerRoute,
} as any)
const PartnerTasksRoute = PartnerTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => PartnerRoute,
} as any)
const SlugAppsSplatRoute = SlugAppsSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SlugAppsRoute,
} as any)
const SlugArtifactsArtifactIdRoute = SlugArtifactsArtifactIdRouteImport.update({
  id: '/artifacts/$artifactId',
  path: '/artifacts/$artifactId',
  getParentRoute: () => SlugRoute,
} as any)
const SlugDepartmentIndexRoute = SlugDepartmentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SlugDepartmentRoute,
} as any)
const SlugDepartmentMembersRoute = SlugDepartmentMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SlugDepartmentRoute,
} as any)
const SlugDepartmentsDepartmentIdRoute =
  SlugDepartmentsDepartmentIdRouteImport.update({
    id: '/departments/$departmentId',
    path: '/departments/$departmentId',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugExternalContactsExternalContactIdRoute =
  SlugExternalContactsExternalContactIdRouteImport.update({
    id: '/external-contacts/$externalContactId',
    path: '/external-contacts/$externalContactId',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugHelpIndexRoute = SlugHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugMyTasksIndexRoute = SlugMyTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SlugMyTasksRoute,
} as any)
const SlugOmniscientIndexRoute = SlugOmniscientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SlugOmniscientRoute,
} as any)
const SlugOmniscientSessionIdRoute = SlugOmniscientSessionIdRouteImport.update({
  id: '/$sessionId',
  path: '/$sessionId',
  getParentRoute: () => SlugOmniscientRoute,
} as any)
const SlugOrgFunctionsIndexRoute = SlugOrgFunctionsIndexRouteImport.update({
  id: '/org-functions/',
  path: '/org-functions/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOrgMembersOrgMemberIdRoute =
  SlugOrgMembersOrgMemberIdRouteImport.update({
    id: '/org-members/$orgMemberId',
    path: '/org-members/$orgMemberId',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugOrganigramIndexRoute = SlugOrganigramIndexRouteImport.update({
  id: '/organigram/',
  path: '/organigram/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOrganizationSettingsIndexRoute =
  SlugOrganizationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationSettingsRoute,
  } as any)
const SlugOrganizationSettingsAppsRoute =
  SlugOrganizationSettingsAppsRouteImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => SlugOrganizationSettingsRoute,
  } as any)
const SlugOrganizationSettingsDataSyncRoute =
  SlugOrganizationSettingsDataSyncRouteImport.update({
    id: '/data-sync',
    path: '/data-sync',
    getParentRoute: () => SlugOrganizationSettingsRoute,
  } as any)
const SlugOrganizationSettingsSettingsRoute =
  SlugOrganizationSettingsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SlugOrganizationSettingsRoute,
  } as any)
const SlugOrganizationSettingsUserManagementRoute =
  SlugOrganizationSettingsUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => SlugOrganizationSettingsRoute,
  } as any)
const SlugOrganizationArtifactsRoute =
  SlugOrganizationArtifactsRouteImport.update({
    id: '/artifacts',
    path: '/artifacts',
    getParentRoute: () => SlugOrganizationRoute,
  } as any)
const SlugOrganizationDepartmentsRoute =
  SlugOrganizationDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => SlugOrganizationRoute,
  } as any)
const SlugOrganizationExternalContactsRoute =
  SlugOrganizationExternalContactsRouteImport.update({
    id: '/external-contacts',
    path: '/external-contacts',
    getParentRoute: () => SlugOrganizationRoute,
  } as any)
const SlugOrganizationFunctionsRoute =
  SlugOrganizationFunctionsRouteImport.update({
    id: '/functions',
    path: '/functions',
    getParentRoute: () => SlugOrganizationRoute,
  } as any)
const SlugOrganizationOrgMembersRoute =
  SlugOrganizationOrgMembersRouteImport.update({
    id: '/org-members',
    path: '/org-members',
    getParentRoute: () => SlugOrganizationRoute,
  } as any)
const SlugOrganizationSystemsRoute = SlugOrganizationSystemsRouteImport.update({
  id: '/systems',
  path: '/systems',
  getParentRoute: () => SlugOrganizationRoute,
} as any)
const SlugOrganizationTeamsRoute = SlugOrganizationTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => SlugOrganizationRoute,
} as any)
const SlugProcessesAllProcessesRoute =
  SlugProcessesAllProcessesRouteImport.update({
    id: '/processes/all-processes',
    path: '/processes/all-processes',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesCreateProcessesRoute =
  SlugProcessesCreateProcessesRouteImport.update({
    id: '/processes/create-processes',
    path: '/processes/create-processes',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesProcessChainsRoute =
  SlugProcessesProcessChainsRouteImport.update({
    id: '/processes/process-chains',
    path: '/processes/process-chains',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesProcessMapRoute = SlugProcessesProcessMapRouteImport.update({
  id: '/processes/process-map',
  path: '/processes/process-map',
  getParentRoute: () => SlugRoute,
} as any)
const SlugRecordingDashboardIndexRoute =
  SlugRecordingDashboardIndexRouteImport.update({
    id: '/recording-dashboard/',
    path: '/recording-dashboard/',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugSystemsIndexRoute = SlugSystemsIndexRouteImport.update({
  id: '/systems/',
  path: '/systems/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugSystemsSystemIdRoute = SlugSystemsSystemIdRouteImport.update({
  id: '/systems/$systemId',
  path: '/systems/$systemId',
  getParentRoute: () => SlugRoute,
} as any)
const SlugSystemsLandscapeRoute = SlugSystemsLandscapeRouteImport.update({
  id: '/systems/landscape',
  path: '/systems/landscape',
  getParentRoute: () => SlugRoute,
} as any)
const SlugSystemsShadowSystemsRoute =
  SlugSystemsShadowSystemsRouteImport.update({
    id: '/systems/shadow-systems',
    path: '/systems/shadow-systems',
    getParentRoute: () => SlugRoute,
  } as any)
const AdminAccountsIndexRoute = AdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiUsageIndexRoute = AdminAiUsageIndexRouteImport.update({
  id: '/ai-usage/',
  path: '/ai-usage/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsIndexRoute = AdminAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditLogsIndexRoute = AdminAuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPartnerContentIndexRoute =
  AdminPartnerContentIndexRouteImport.update({
    id: '/partner-content/',
    path: '/partner-content/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const PartnerAppsSplatRoute = PartnerAppsSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PartnerAppsRoute,
} as any)
const PartnerOrganizationIndexRoute =
  PartnerOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => PartnerRoute,
  } as any)
const PartnerOrganizationUsersRoute =
  PartnerOrganizationUsersRouteImport.update({
    id: '/organization/users',
    path: '/organization/users',
    getParentRoute: () => PartnerRoute,
  } as any)
const SlugDepartmentMembersIndexRoute =
  SlugDepartmentMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugDepartmentMembersRoute,
  } as any)
const SlugDepartmentTeamsIndexRoute =
  SlugDepartmentTeamsIndexRouteImport.update({
    id: '/teams/',
    path: '/teams/',
    getParentRoute: () => SlugDepartmentRoute,
  } as any)
const SlugHelpTicketsIndexRoute = SlugHelpTicketsIndexRouteImport.update({
  id: '/help/tickets/',
  path: '/help/tickets/',
  getParentRoute: () => SlugRoute,
} as any)
const SlugOrganizationArtifactsIndexRoute =
  SlugOrganizationArtifactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationArtifactsRoute,
  } as any)
const SlugOrganizationArtifactsArtifactIdRoute =
  SlugOrganizationArtifactsArtifactIdRouteImport.update({
    id: '/$artifactId',
    path: '/$artifactId',
    getParentRoute: () => SlugOrganizationArtifactsRoute,
  } as any)
const SlugOrganizationDepartmentsIndexRoute =
  SlugOrganizationDepartmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationDepartmentsRoute,
  } as any)
const SlugOrganizationDepartmentsDepartmentIdRoute =
  SlugOrganizationDepartmentsDepartmentIdRouteImport.update({
    id: '/$departmentId',
    path: '/$departmentId',
    getParentRoute: () => SlugOrganizationDepartmentsRoute,
  } as any)
const SlugOrganizationDepartmentsBulkUploadRoute =
  SlugOrganizationDepartmentsBulkUploadRouteImport.update({
    id: '/bulk-upload',
    path: '/bulk-upload',
    getParentRoute: () => SlugOrganizationDepartmentsRoute,
  } as any)
const SlugOrganizationExternalContactsIndexRoute =
  SlugOrganizationExternalContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationExternalContactsRoute,
  } as any)
const SlugOrganizationExternalContactsExternalContactIdRoute =
  SlugOrganizationExternalContactsExternalContactIdRouteImport.update({
    id: '/$externalContactId',
    path: '/$externalContactId',
    getParentRoute: () => SlugOrganizationExternalContactsRoute,
  } as any)
const SlugOrganizationFunctionsIndexRoute =
  SlugOrganizationFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationFunctionsRoute,
  } as any)
const SlugOrganizationFunctionsOrgFunctionIdRoute =
  SlugOrganizationFunctionsOrgFunctionIdRouteImport.update({
    id: '/$orgFunctionId',
    path: '/$orgFunctionId',
    getParentRoute: () => SlugOrganizationFunctionsRoute,
  } as any)
const SlugOrganizationOrgMembersIndexRoute =
  SlugOrganizationOrgMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationOrgMembersRoute,
  } as any)
const SlugOrganizationOrgMembersOrgMemberIdRoute =
  SlugOrganizationOrgMembersOrgMemberIdRouteImport.update({
    id: '/$orgMemberId',
    path: '/$orgMemberId',
    getParentRoute: () => SlugOrganizationOrgMembersRoute,
  } as any)
const SlugOrganizationSystemsIndexRoute =
  SlugOrganizationSystemsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationSystemsRoute,
  } as any)
const SlugOrganizationSystemsSystemIdRoute =
  SlugOrganizationSystemsSystemIdRouteImport.update({
    id: '/$systemId',
    path: '/$systemId',
    getParentRoute: () => SlugOrganizationSystemsRoute,
  } as any)
const SlugOrganizationTeamsIndexRoute =
  SlugOrganizationTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugOrganizationTeamsRoute,
  } as any)
const SlugOrganizationTeamsOrgFunctionIdRoute =
  SlugOrganizationTeamsOrgFunctionIdRouteImport.update({
    id: '/$orgFunctionId',
    path: '/$orgFunctionId',
    getParentRoute: () => SlugOrganizationTeamsRoute,
  } as any)
const SlugProcessesAllProcessesIndexRoute =
  SlugProcessesAllProcessesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugProcessesAllProcessesRoute,
  } as any)
const SlugProcessesAllProcessesProcessIdRoute =
  SlugProcessesAllProcessesProcessIdRouteImport.update({
    id: '/$processId',
    path: '/$processId',
    getParentRoute: () => SlugProcessesAllProcessesRoute,
  } as any)
const SlugProcessesCreateProcessesIndexRoute =
  SlugProcessesCreateProcessesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugProcessesCreateProcessesRoute,
  } as any)
const SlugProcessesEditorIndexRoute =
  SlugProcessesEditorIndexRouteImport.update({
    id: '/processes/editor/',
    path: '/processes/editor/',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesEditorProcessIdRoute =
  SlugProcessesEditorProcessIdRouteImport.update({
    id: '/processes/editor/$processId',
    path: '/processes/editor/$processId',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesProcessChainsIndexRoute =
  SlugProcessesProcessChainsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugProcessesProcessChainsRoute,
  } as any)
const SlugProcessesProcessChainsChainIdRoute =
  SlugProcessesProcessChainsChainIdRouteImport.update({
    id: '/$chainId',
    path: '/$chainId',
    getParentRoute: () => SlugProcessesProcessChainsRoute,
  } as any)
const AdminAccountsAccountIdIndexRoute =
  AdminAccountsAccountIdIndexRouteImport.update({
    id: '/accounts/$accountId/',
    path: '/accounts/$accountId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminTenantsTenantIdIndexRoute =
  AdminTenantsTenantIdIndexRouteImport.update({
    id: '/tenants/$tenantId/',
    path: '/tenants/$tenantId/',
    getParentRoute: () => AdminRoute,
  } as any)
const SlugHelpTicketsTicketIdIndexRoute =
  SlugHelpTicketsTicketIdIndexRouteImport.update({
    id: '/help/tickets/$ticketId/',
    path: '/help/tickets/$ticketId/',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesAllProcessesProcessIdIndexRoute =
  SlugProcessesAllProcessesProcessIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SlugProcessesAllProcessesProcessIdRoute,
  } as any)
const SlugProcessesAllProcessesProcessIdFlowFullscreenRoute =
  SlugProcessesAllProcessesProcessIdFlowFullscreenRouteImport.update({
    id: '/flow-fullscreen',
    path: '/flow-fullscreen',
    getParentRoute: () => SlugProcessesAllProcessesProcessIdRoute,
  } as any)
const SlugProcessesRecordingStartRecordingProcessIdRoute =
  SlugProcessesRecordingStartRecordingProcessIdRouteImport.update({
    id: '/processes/recording/start-recording/$processId',
    path: '/processes/recording/start-recording/$processId',
    getParentRoute: () => SlugRoute,
  } as any)
const SlugProcessesRecordingStepRecordingRecordingIdRoute =
  SlugProcessesRecordingStepRecordingRecordingIdRouteImport.update({
    id: '/processes/recording/step-recording/$recordingId',
    path: '/processes/recording/step-recording/$recordingId',
    getParentRoute: () => SlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/partner': typeof PartnerRouteWithChildren
  '/select-workspace': typeof SelectWorkspaceRoute
  '/version': typeof VersionRoute
  '/$slug/apps': typeof SlugAppsRouteWithChildren
  '/$slug/department': typeof SlugDepartmentRouteWithChildren
  '/$slug/initial-setup': typeof SlugInitialSetupRoute
  '/$slug/my-tasks': typeof SlugMyTasksRouteWithChildren
  '/$slug/omniscient': typeof SlugOmniscientRouteWithChildren
  '/$slug/organization': typeof SlugOrganizationRouteWithChildren
  '/$slug/organization-settings': typeof SlugOrganizationSettingsRouteWithChildren
  '/$slug/seat-overrun': typeof SlugSeatOverrunRoute
  '/$slug/setup-pending': typeof SlugSetupPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/partner/apps': typeof PartnerAppsRouteWithChildren
  '/partner/tasks': typeof PartnerTasksRoute
  '/$slug/': typeof SlugIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/partner/': typeof PartnerIndexRoute
  '/$slug/apps/$': typeof SlugAppsSplatRoute
  '/$slug/artifacts/$artifactId': typeof SlugArtifactsArtifactIdRoute
  '/$slug/department/members': typeof SlugDepartmentMembersRouteWithChildren
  '/$slug/departments/$departmentId': typeof SlugDepartmentsDepartmentIdRoute
  '/$slug/external-contacts/$externalContactId': typeof SlugExternalContactsExternalContactIdRoute
  '/$slug/omniscient/$sessionId': typeof SlugOmniscientSessionIdRoute
  '/$slug/org-members/$orgMemberId': typeof SlugOrgMembersOrgMemberIdRoute
  '/$slug/organization-settings/apps': typeof SlugOrganizationSettingsAppsRoute
  '/$slug/organization-settings/data-sync': typeof SlugOrganizationSettingsDataSyncRoute
  '/$slug/organization-settings/settings': typeof SlugOrganizationSettingsSettingsRoute
  '/$slug/organization-settings/user-management': typeof SlugOrganizationSettingsUserManagementRoute
  '/$slug/organization/artifacts': typeof SlugOrganizationArtifactsRouteWithChildren
  '/$slug/organization/departments': typeof SlugOrganizationDepartmentsRouteWithChildren
  '/$slug/organization/external-contacts': typeof SlugOrganizationExternalContactsRouteWithChildren
  '/$slug/organization/functions': typeof SlugOrganizationFunctionsRouteWithChildren
  '/$slug/organization/org-members': typeof SlugOrganizationOrgMembersRouteWithChildren
  '/$slug/organization/systems': typeof SlugOrganizationSystemsRouteWithChildren
  '/$slug/organization/teams': typeof SlugOrganizationTeamsRouteWithChildren
  '/$slug/processes/all-processes': typeof SlugProcessesAllProcessesRouteWithChildren
  '/$slug/processes/create-processes': typeof SlugProcessesCreateProcessesRouteWithChildren
  '/$slug/processes/process-chains': typeof SlugProcessesProcessChainsRouteWithChildren
  '/$slug/processes/process-map': typeof SlugProcessesProcessMapRoute
  '/$slug/systems/$systemId': typeof SlugSystemsSystemIdRoute
  '/$slug/systems/landscape': typeof SlugSystemsLandscapeRoute
  '/$slug/systems/shadow-systems': typeof SlugSystemsShadowSystemsRoute
  '/partner/apps/$': typeof PartnerAppsSplatRoute
  '/partner/organization/users': typeof PartnerOrganizationUsersRoute
  '/$slug/department/': typeof SlugDepartmentIndexRoute
  '/$slug/help/': typeof SlugHelpIndexRoute
  '/$slug/my-tasks/': typeof SlugMyTasksIndexRoute
  '/$slug/omniscient/': typeof SlugOmniscientIndexRoute
  '/$slug/org-functions/': typeof SlugOrgFunctionsIndexRoute
  '/$slug/organigram/': typeof SlugOrganigramIndexRoute
  '/$slug/organization-settings/': typeof SlugOrganizationSettingsIndexRoute
  '/$slug/recording-dashboard/': typeof SlugRecordingDashboardIndexRoute
  '/$slug/systems/': typeof SlugSystemsIndexRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/ai-usage/': typeof AdminAiUsageIndexRoute
  '/admin/analytics/': typeof AdminAnalyticsIndexRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/admin/partner-content/': typeof AdminPartnerContentIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/partner/organization/': typeof PartnerOrganizationIndexRoute
  '/$slug/organization/artifacts/$artifactId': typeof SlugOrganizationArtifactsArtifactIdRoute
  '/$slug/organization/departments/$departmentId': typeof SlugOrganizationDepartmentsDepartmentIdRoute
  '/$slug/organization/departments/bulk-upload': typeof SlugOrganizationDepartmentsBulkUploadRoute
  '/$slug/organization/external-contacts/$externalContactId': typeof SlugOrganizationExternalContactsExternalContactIdRoute
  '/$slug/organization/functions/$orgFunctionId': typeof SlugOrganizationFunctionsOrgFunctionIdRoute
  '/$slug/organization/org-members/$orgMemberId': typeof SlugOrganizationOrgMembersOrgMemberIdRoute
  '/$slug/organization/systems/$systemId': typeof SlugOrganizationSystemsSystemIdRoute
  '/$slug/organization/teams/$orgFunctionId': typeof SlugOrganizationTeamsOrgFunctionIdRoute
  '/$slug/processes/all-processes/$processId': typeof SlugProcessesAllProcessesProcessIdRouteWithChildren
  '/$slug/processes/editor/$processId': typeof SlugProcessesEditorProcessIdRoute
  '/$slug/processes/process-chains/$chainId': typeof SlugProcessesProcessChainsChainIdRoute
  '/$slug/department/members/': typeof SlugDepartmentMembersIndexRoute
  '/$slug/department/teams/': typeof SlugDepartmentTeamsIndexRoute
  '/$slug/help/tickets/': typeof SlugHelpTicketsIndexRoute
  '/$slug/organization/artifacts/': typeof SlugOrganizationArtifactsIndexRoute
  '/$slug/organization/departments/': typeof SlugOrganizationDepartmentsIndexRoute
  '/$slug/organization/external-contacts/': typeof SlugOrganizationExternalContactsIndexRoute
  '/$slug/organization/functions/': typeof SlugOrganizationFunctionsIndexRoute
  '/$slug/organization/org-members/': typeof SlugOrganizationOrgMembersIndexRoute
  '/$slug/organization/systems/': typeof SlugOrganizationSystemsIndexRoute
  '/$slug/organization/teams/': typeof SlugOrganizationTeamsIndexRoute
  '/$slug/processes/all-processes/': typeof SlugProcessesAllProcessesIndexRoute
  '/$slug/processes/create-processes/': typeof SlugProcessesCreateProcessesIndexRoute
  '/$slug/processes/editor/': typeof SlugProcessesEditorIndexRoute
  '/$slug/processes/process-chains/': typeof SlugProcessesProcessChainsIndexRoute
  '/admin/accounts/$accountId/': typeof AdminAccountsAccountIdIndexRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
  '/$slug/processes/all-processes/$processId/flow-fullscreen': typeof SlugProcessesAllProcessesProcessIdFlowFullscreenRoute
  '/$slug/processes/recording/start-recording/$processId': typeof SlugProcessesRecordingStartRecordingProcessIdRoute
  '/$slug/processes/recording/step-recording/$recordingId': typeof SlugProcessesRecordingStepRecordingRecordingIdRoute
  '/$slug/help/tickets/$ticketId/': typeof SlugHelpTicketsTicketIdIndexRoute
  '/$slug/processes/all-processes/$processId/': typeof SlugProcessesAllProcessesProcessIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/select-workspace': typeof SelectWorkspaceRoute
  '/version': typeof VersionRoute
  '/$slug/apps': typeof SlugAppsRouteWithChildren
  '/$slug/initial-setup': typeof SlugInitialSetupRoute
  '/$slug/organization': typeof SlugOrganizationRouteWithChildren
  '/$slug/seat-overrun': typeof SlugSeatOverrunRoute
  '/$slug/setup-pending': typeof SlugSetupPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/partner/apps': typeof PartnerAppsRouteWithChildren
  '/partner/tasks': typeof PartnerTasksRoute
  '/$slug': typeof SlugIndexRoute
  '/admin': typeof AdminIndexRoute
  '/partner': typeof PartnerIndexRoute
  '/$slug/apps/$': typeof SlugAppsSplatRoute
  '/$slug/artifacts/$artifactId': typeof SlugArtifactsArtifactIdRoute
  '/$slug/departments/$departmentId': typeof SlugDepartmentsDepartmentIdRoute
  '/$slug/external-contacts/$externalContactId': typeof SlugExternalContactsExternalContactIdRoute
  '/$slug/omniscient/$sessionId': typeof SlugOmniscientSessionIdRoute
  '/$slug/org-members/$orgMemberId': typeof SlugOrgMembersOrgMemberIdRoute
  '/$slug/organization-settings/apps': typeof SlugOrganizationSettingsAppsRoute
  '/$slug/organization-settings/data-sync': typeof SlugOrganizationSettingsDataSyncRoute
  '/$slug/organization-settings/settings': typeof SlugOrganizationSettingsSettingsRoute
  '/$slug/organization-settings/user-management': typeof SlugOrganizationSettingsUserManagementRoute
  '/$slug/processes/process-map': typeof SlugProcessesProcessMapRoute
  '/$slug/systems/$systemId': typeof SlugSystemsSystemIdRoute
  '/$slug/systems/landscape': typeof SlugSystemsLandscapeRoute
  '/$slug/systems/shadow-systems': typeof SlugSystemsShadowSystemsRoute
  '/partner/apps/$': typeof PartnerAppsSplatRoute
  '/partner/organization/users': typeof PartnerOrganizationUsersRoute
  '/$slug/department': typeof SlugDepartmentIndexRoute
  '/$slug/help': typeof SlugHelpIndexRoute
  '/$slug/my-tasks': typeof SlugMyTasksIndexRoute
  '/$slug/omniscient': typeof SlugOmniscientIndexRoute
  '/$slug/org-functions': typeof SlugOrgFunctionsIndexRoute
  '/$slug/organigram': typeof SlugOrganigramIndexRoute
  '/$slug/organization-settings': typeof SlugOrganizationSettingsIndexRoute
  '/$slug/recording-dashboard': typeof SlugRecordingDashboardIndexRoute
  '/$slug/systems': typeof SlugSystemsIndexRoute
  '/admin/accounts': typeof AdminAccountsIndexRoute
  '/admin/ai-usage': typeof AdminAiUsageIndexRoute
  '/admin/analytics': typeof AdminAnalyticsIndexRoute
  '/admin/audit-logs': typeof AdminAuditLogsIndexRoute
  '/admin/partner-content': typeof AdminPartnerContentIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/tenants': typeof AdminTenantsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/partner/organization': typeof PartnerOrganizationIndexRoute
  '/$slug/organization/artifacts/$artifactId': typeof SlugOrganizationArtifactsArtifactIdRoute
  '/$slug/organization/departments/$departmentId': typeof SlugOrganizationDepartmentsDepartmentIdRoute
  '/$slug/organization/departments/bulk-upload': typeof SlugOrganizationDepartmentsBulkUploadRoute
  '/$slug/organization/external-contacts/$externalContactId': typeof SlugOrganizationExternalContactsExternalContactIdRoute
  '/$slug/organization/functions/$orgFunctionId': typeof SlugOrganizationFunctionsOrgFunctionIdRoute
  '/$slug/organization/org-members/$orgMemberId': typeof SlugOrganizationOrgMembersOrgMemberIdRoute
  '/$slug/organization/systems/$systemId': typeof SlugOrganizationSystemsSystemIdRoute
  '/$slug/organization/teams/$orgFunctionId': typeof SlugOrganizationTeamsOrgFunctionIdRoute
  '/$slug/processes/editor/$processId': typeof SlugProcessesEditorProcessIdRoute
  '/$slug/processes/process-chains/$chainId': typeof SlugProcessesProcessChainsChainIdRoute
  '/$slug/department/members': typeof SlugDepartmentMembersIndexRoute
  '/$slug/department/teams': typeof SlugDepartmentTeamsIndexRoute
  '/$slug/help/tickets': typeof SlugHelpTicketsIndexRoute
  '/$slug/organization/artifacts': typeof SlugOrganizationArtifactsIndexRoute
  '/$slug/organization/departments': typeof SlugOrganizationDepartmentsIndexRoute
  '/$slug/organization/external-contacts': typeof SlugOrganizationExternalContactsIndexRoute
  '/$slug/organization/functions': typeof SlugOrganizationFunctionsIndexRoute
  '/$slug/organization/org-members': typeof SlugOrganizationOrgMembersIndexRoute
  '/$slug/organization/systems': typeof SlugOrganizationSystemsIndexRoute
  '/$slug/organization/teams': typeof SlugOrganizationTeamsIndexRoute
  '/$slug/processes/all-processes': typeof SlugProcessesAllProcessesIndexRoute
  '/$slug/processes/create-processes': typeof SlugProcessesCreateProcessesIndexRoute
  '/$slug/processes/editor': typeof SlugProcessesEditorIndexRoute
  '/$slug/processes/process-chains': typeof SlugProcessesProcessChainsIndexRoute
  '/admin/accounts/$accountId': typeof AdminAccountsAccountIdIndexRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdIndexRoute
  '/$slug/processes/all-processes/$processId/flow-fullscreen': typeof SlugProcessesAllProcessesProcessIdFlowFullscreenRoute
  '/$slug/processes/recording/start-recording/$processId': typeof SlugProcessesRecordingStartRecordingProcessIdRoute
  '/$slug/processes/recording/step-recording/$recordingId': typeof SlugProcessesRecordingStepRecordingRecordingIdRoute
  '/$slug/help/tickets/$ticketId': typeof SlugHelpTicketsTicketIdIndexRoute
  '/$slug/processes/all-processes/$processId': typeof SlugProcessesAllProcessesProcessIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$slug': typeof SlugRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/partner': typeof PartnerRouteWithChildren
  '/select-workspace': typeof SelectWorkspaceRoute
  '/version': typeof VersionRoute
  '/$slug/apps': typeof SlugAppsRouteWithChildren
  '/$slug/department': typeof SlugDepartmentRouteWithChildren
  '/$slug/initial-setup': typeof SlugInitialSetupRoute
  '/$slug/my-tasks': typeof SlugMyTasksRouteWithChildren
  '/$slug/omniscient': typeof SlugOmniscientRouteWithChildren
  '/$slug/organization': typeof SlugOrganizationRouteWithChildren
  '/$slug/organization-settings': typeof SlugOrganizationSettingsRouteWithChildren
  '/$slug/seat-overrun': typeof SlugSeatOverrunRoute
  '/$slug/setup-pending': typeof SlugSetupPendingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/partner/apps': typeof PartnerAppsRouteWithChildren
  '/partner/tasks': typeof PartnerTasksRoute
  '/$slug/': typeof SlugIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/partner/': typeof PartnerIndexRoute
  '/$slug/apps/$': typeof SlugAppsSplatRoute
  '/$slug/artifacts/$artifactId': typeof SlugArtifactsArtifactIdRoute
  '/$slug/department/members': typeof SlugDepartmentMembersRouteWithChildren
  '/$slug/departments/$departmentId': typeof SlugDepartmentsDepartmentIdRoute
  '/$slug/external-contacts/$externalContactId': typeof SlugExternalContactsExternalContactIdRoute
  '/$slug/omniscient/$sessionId': typeof SlugOmniscientSessionIdRoute
  '/$slug/org-members/$orgMemberId': typeof SlugOrgMembersOrgMemberIdRoute
  '/$slug/organization-settings/apps': typeof SlugOrganizationSettingsAppsRoute
  '/$slug/organization-settings/data-sync': typeof SlugOrganizationSettingsDataSyncRoute
  '/$slug/organization-settings/settings': typeof SlugOrganizationSettingsSettingsRoute
  '/$slug/organization-settings/user-management': typeof SlugOrganizationSettingsUserManagementRoute
  '/$slug/organization/artifacts': typeof SlugOrganizationArtifactsRouteWithChildren
  '/$slug/organization/departments': typeof SlugOrganizationDepartmentsRouteWithChildren
  '/$slug/organization/external-contacts': typeof SlugOrganizationExternalContactsRouteWithChildren
  '/$slug/organization/functions': typeof SlugOrganizationFunctionsRouteWithChildren
  '/$slug/organization/org-members': typeof SlugOrganizationOrgMembersRouteWithChildren
  '/$slug/organization/systems': typeof SlugOrganizationSystemsRouteWithChildren
  '/$slug/organization/teams': typeof SlugOrganizationTeamsRouteWithChildren
  '/$slug/processes/all-processes': typeof SlugProcessesAllProcessesRouteWithChildren
  '/$slug/processes/create-processes': typeof SlugProcessesCreateProcessesRouteWithChildren
  '/$slug/processes/process-chains': typeof SlugProcessesProcessChainsRouteWithChildren
  '/$slug/processes/process-map': typeof SlugProcessesProcessMapRoute
  '/$slug/systems/$systemId': typeof SlugSystemsSystemIdRoute
  '/$slug/systems/landscape': typeof SlugSystemsLandscapeRoute
  '/$slug/systems/shadow-systems': typeof SlugSystemsShadowSystemsRoute
  '/partner/apps/$': typeof PartnerAppsSplatRoute
  '/partner/organization/users': typeof PartnerOrganizationUsersRoute
  '/$slug/department/': typeof SlugDepartmentIndexRoute
  '/$slug/help/': typeof SlugHelpIndexRoute
  '/$slug/my-tasks/': typeof SlugMyTasksIndexRoute
  '/$slug/omniscient/': typeof SlugOmniscientIndexRoute
  '/$slug/org-functions/': typeof SlugOrgFunctionsIndexRoute
  '/$slug/organigram/': typeof SlugOrganigramIndexRoute
  '/$slug/organization-settings/': typeof SlugOrganizationSettingsIndexRoute
  '/$slug/recording-dashboard/': typeof SlugRecordingDashboardIndexRoute
  '/$slug/systems/': typeof SlugSystemsIndexRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/ai-usage/': typeof AdminAiUsageIndexRoute
  '/admin/analytics/': typeof AdminAnalyticsIndexRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/admin/partner-content/': typeof AdminPartnerContentIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/partner/organization/': typeof PartnerOrganizationIndexRoute
  '/$slug/organization/artifacts/$artifactId': typeof SlugOrganizationArtifactsArtifactIdRoute
  '/$slug/organization/departments/$departmentId': typeof SlugOrganizationDepartmentsDepartmentIdRoute
  '/$slug/organization/departments/bulk-upload': typeof SlugOrganizationDepartmentsBulkUploadRoute
  '/$slug/organization/external-contacts/$externalContactId': typeof SlugOrganizationExternalContactsExternalContactIdRoute
  '/$slug/organization/functions/$orgFunctionId': typeof SlugOrganizationFunctionsOrgFunctionIdRoute
  '/$slug/organization/org-members/$orgMemberId': typeof SlugOrganizationOrgMembersOrgMemberIdRoute
  '/$slug/organization/systems/$systemId': typeof SlugOrganizationSystemsSystemIdRoute
  '/$slug/organization/teams/$orgFunctionId': typeof SlugOrganizationTeamsOrgFunctionIdRoute
  '/$slug/processes/all-processes/$processId': typeof SlugProcessesAllProcessesProcessIdRouteWithChildren
  '/$slug/processes/editor/$processId': typeof SlugProcessesEditorProcessIdRoute
  '/$slug/processes/process-chains/$chainId': typeof SlugProcessesProcessChainsChainIdRoute
  '/$slug/department/members/': typeof SlugDepartmentMembersIndexRoute
  '/$slug/department/teams/': typeof SlugDepartmentTeamsIndexRoute
  '/$slug/help/tickets/': typeof SlugHelpTicketsIndexRoute
  '/$slug/organization/artifacts/': typeof SlugOrganizationArtifactsIndexRoute
  '/$slug/organization/departments/': typeof SlugOrganizationDepartmentsIndexRoute
  '/$slug/organization/external-contacts/': typeof SlugOrganizationExternalContactsIndexRoute
  '/$slug/organization/functions/': typeof SlugOrganizationFunctionsIndexRoute
  '/$slug/organization/org-members/': typeof SlugOrganizationOrgMembersIndexRoute
  '/$slug/organization/systems/': typeof SlugOrganizationSystemsIndexRoute
  '/$slug/organization/teams/': typeof SlugOrganizationTeamsIndexRoute
  '/$slug/processes/all-processes/': typeof SlugProcessesAllProcessesIndexRoute
  '/$slug/processes/create-processes/': typeof SlugProcessesCreateProcessesIndexRoute
  '/$slug/processes/editor/': typeof SlugProcessesEditorIndexRoute
  '/$slug/processes/process-chains/': typeof SlugProcessesProcessChainsIndexRoute
  '/admin/accounts/$accountId/': typeof AdminAccountsAccountIdIndexRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
  '/$slug/processes/all-processes/$processId/flow-fullscreen': typeof SlugProcessesAllProcessesProcessIdFlowFullscreenRoute
  '/$slug/processes/recording/start-recording/$processId': typeof SlugProcessesRecordingStartRecordingProcessIdRoute
  '/$slug/processes/recording/step-recording/$recordingId': typeof SlugProcessesRecordingStepRecordingRecordingIdRoute
  '/$slug/help/tickets/$ticketId/': typeof SlugHelpTicketsTicketIdIndexRoute
  '/$slug/processes/all-processes/$processId/': typeof SlugProcessesAllProcessesProcessIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/admin'
    | '/login'
    | '/partner'
    | '/select-workspace'
    | '/version'
    | '/$slug/apps'
    | '/$slug/department'
    | '/$slug/initial-setup'
    | '/$slug/my-tasks'
    | '/$slug/omniscient'
    | '/$slug/organization'
    | '/$slug/organization-settings'
    | '/$slug/seat-overrun'
    | '/$slug/setup-pending'
    | '/auth/callback'
    | '/partner/apps'
    | '/partner/tasks'
    | '/$slug/'
    | '/admin/'
    | '/partner/'
    | '/$slug/apps/$'
    | '/$slug/artifacts/$artifactId'
    | '/$slug/department/members'
    | '/$slug/departments/$departmentId'
    | '/$slug/external-contacts/$externalContactId'
    | '/$slug/omniscient/$sessionId'
    | '/$slug/org-members/$orgMemberId'
    | '/$slug/organization-settings/apps'
    | '/$slug/organization-settings/data-sync'
    | '/$slug/organization-settings/settings'
    | '/$slug/organization-settings/user-management'
    | '/$slug/organization/artifacts'
    | '/$slug/organization/departments'
    | '/$slug/organization/external-contacts'
    | '/$slug/organization/functions'
    | '/$slug/organization/org-members'
    | '/$slug/organization/systems'
    | '/$slug/organization/teams'
    | '/$slug/processes/all-processes'
    | '/$slug/processes/create-processes'
    | '/$slug/processes/process-chains'
    | '/$slug/processes/process-map'
    | '/$slug/systems/$systemId'
    | '/$slug/systems/landscape'
    | '/$slug/systems/shadow-systems'
    | '/partner/apps/$'
    | '/partner/organization/users'
    | '/$slug/department/'
    | '/$slug/help/'
    | '/$slug/my-tasks/'
    | '/$slug/omniscient/'
    | '/$slug/org-functions/'
    | '/$slug/organigram/'
    | '/$slug/organization-settings/'
    | '/$slug/recording-dashboard/'
    | '/$slug/systems/'
    | '/admin/accounts/'
    | '/admin/ai-usage/'
    | '/admin/analytics/'
    | '/admin/audit-logs/'
    | '/admin/partner-content/'
    | '/admin/settings/'
    | '/admin/tenants/'
    | '/admin/users/'
    | '/partner/organization/'
    | '/$slug/organization/artifacts/$artifactId'
    | '/$slug/organization/departments/$departmentId'
    | '/$slug/organization/departments/bulk-upload'
    | '/$slug/organization/external-contacts/$externalContactId'
    | '/$slug/organization/functions/$orgFunctionId'
    | '/$slug/organization/org-members/$orgMemberId'
    | '/$slug/organization/systems/$systemId'
    | '/$slug/organization/teams/$orgFunctionId'
    | '/$slug/processes/all-processes/$processId'
    | '/$slug/processes/editor/$processId'
    | '/$slug/processes/process-chains/$chainId'
    | '/$slug/department/members/'
    | '/$slug/department/teams/'
    | '/$slug/help/tickets/'
    | '/$slug/organization/artifacts/'
    | '/$slug/organization/departments/'
    | '/$slug/organization/external-contacts/'
    | '/$slug/organization/functions/'
    | '/$slug/organization/org-members/'
    | '/$slug/organization/systems/'
    | '/$slug/organization/teams/'
    | '/$slug/processes/all-processes/'
    | '/$slug/processes/create-processes/'
    | '/$slug/processes/editor/'
    | '/$slug/processes/process-chains/'
    | '/admin/accounts/$accountId/'
    | '/admin/tenants/$tenantId/'
    | '/$slug/processes/all-processes/$processId/flow-fullscreen'
    | '/$slug/processes/recording/start-recording/$processId'
    | '/$slug/processes/recording/step-recording/$recordingId'
    | '/$slug/help/tickets/$ticketId/'
    | '/$slug/processes/all-processes/$processId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/select-workspace'
    | '/version'
    | '/$slug/apps'
    | '/$slug/initial-setup'
    | '/$slug/organization'
    | '/$slug/seat-overrun'
    | '/$slug/setup-pending'
    | '/auth/callback'
    | '/partner/apps'
    | '/partner/tasks'
    | '/$slug'
    | '/admin'
    | '/partner'
    | '/$slug/apps/$'
    | '/$slug/artifacts/$artifactId'
    | '/$slug/departments/$departmentId'
    | '/$slug/external-contacts/$externalContactId'
    | '/$slug/omniscient/$sessionId'
    | '/$slug/org-members/$orgMemberId'
    | '/$slug/organization-settings/apps'
    | '/$slug/organization-settings/data-sync'
    | '/$slug/organization-settings/settings'
    | '/$slug/organization-settings/user-management'
    | '/$slug/processes/process-map'
    | '/$slug/systems/$systemId'
    | '/$slug/systems/landscape'
    | '/$slug/systems/shadow-systems'
    | '/partner/apps/$'
    | '/partner/organization/users'
    | '/$slug/department'
    | '/$slug/help'
    | '/$slug/my-tasks'
    | '/$slug/omniscient'
    | '/$slug/org-functions'
    | '/$slug/organigram'
    | '/$slug/organization-settings'
    | '/$slug/recording-dashboard'
    | '/$slug/systems'
    | '/admin/accounts'
    | '/admin/ai-usage'
    | '/admin/analytics'
    | '/admin/audit-logs'
    | '/admin/partner-content'
    | '/admin/settings'
    | '/admin/tenants'
    | '/admin/users'
    | '/partner/organization'
    | '/$slug/organization/artifacts/$artifactId'
    | '/$slug/organization/departments/$departmentId'
    | '/$slug/organization/departments/bulk-upload'
    | '/$slug/organization/external-contacts/$externalContactId'
    | '/$slug/organization/functions/$orgFunctionId'
    | '/$slug/organization/org-members/$orgMemberId'
    | '/$slug/organization/systems/$systemId'
    | '/$slug/organization/teams/$orgFunctionId'
    | '/$slug/processes/editor/$processId'
    | '/$slug/processes/process-chains/$chainId'
    | '/$slug/department/members'
    | '/$slug/department/teams'
    | '/$slug/help/tickets'
    | '/$slug/organization/artifacts'
    | '/$slug/organization/departments'
    | '/$slug/organization/external-contacts'
    | '/$slug/organization/functions'
    | '/$slug/organization/org-members'
    | '/$slug/organization/systems'
    | '/$slug/organization/teams'
    | '/$slug/processes/all-processes'
    | '/$slug/processes/create-processes'
    | '/$slug/processes/editor'
    | '/$slug/processes/process-chains'
    | '/admin/accounts/$accountId'
    | '/admin/tenants/$tenantId'
    | '/$slug/processes/all-processes/$processId/flow-fullscreen'
    | '/$slug/processes/recording/start-recording/$processId'
    | '/$slug/processes/recording/step-recording/$recordingId'
    | '/$slug/help/tickets/$ticketId'
    | '/$slug/processes/all-processes/$processId'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/admin'
    | '/login'
    | '/partner'
    | '/select-workspace'
    | '/version'
    | '/$slug/apps'
    | '/$slug/department'
    | '/$slug/initial-setup'
    | '/$slug/my-tasks'
    | '/$slug/omniscient'
    | '/$slug/organization'
    | '/$slug/organization-settings'
    | '/$slug/seat-overrun'
    | '/$slug/setup-pending'
    | '/auth/callback'
    | '/partner/apps'
    | '/partner/tasks'
    | '/$slug/'
    | '/admin/'
    | '/partner/'
    | '/$slug/apps/$'
    | '/$slug/artifacts/$artifactId'
    | '/$slug/department/members'
    | '/$slug/departments/$departmentId'
    | '/$slug/external-contacts/$externalContactId'
    | '/$slug/omniscient/$sessionId'
    | '/$slug/org-members/$orgMemberId'
    | '/$slug/organization-settings/apps'
    | '/$slug/organization-settings/data-sync'
    | '/$slug/organization-settings/settings'
    | '/$slug/organization-settings/user-management'
    | '/$slug/organization/artifacts'
    | '/$slug/organization/departments'
    | '/$slug/organization/external-contacts'
    | '/$slug/organization/functions'
    | '/$slug/organization/org-members'
    | '/$slug/organization/systems'
    | '/$slug/organization/teams'
    | '/$slug/processes/all-processes'
    | '/$slug/processes/create-processes'
    | '/$slug/processes/process-chains'
    | '/$slug/processes/process-map'
    | '/$slug/systems/$systemId'
    | '/$slug/systems/landscape'
    | '/$slug/systems/shadow-systems'
    | '/partner/apps/$'
    | '/partner/organization/users'
    | '/$slug/department/'
    | '/$slug/help/'
    | '/$slug/my-tasks/'
    | '/$slug/omniscient/'
    | '/$slug/org-functions/'
    | '/$slug/organigram/'
    | '/$slug/organization-settings/'
    | '/$slug/recording-dashboard/'
    | '/$slug/systems/'
    | '/admin/accounts/'
    | '/admin/ai-usage/'
    | '/admin/analytics/'
    | '/admin/audit-logs/'
    | '/admin/partner-content/'
    | '/admin/settings/'
    | '/admin/tenants/'
    | '/admin/users/'
    | '/partner/organization/'
    | '/$slug/organization/artifacts/$artifactId'
    | '/$slug/organization/departments/$departmentId'
    | '/$slug/organization/departments/bulk-upload'
    | '/$slug/organization/external-contacts/$externalContactId'
    | '/$slug/organization/functions/$orgFunctionId'
    | '/$slug/organization/org-members/$orgMemberId'
    | '/$slug/organization/systems/$systemId'
    | '/$slug/organization/teams/$orgFunctionId'
    | '/$slug/processes/all-processes/$processId'
    | '/$slug/processes/editor/$processId'
    | '/$slug/processes/process-chains/$chainId'
    | '/$slug/department/members/'
    | '/$slug/department/teams/'
    | '/$slug/help/tickets/'
    | '/$slug/organization/artifacts/'
    | '/$slug/organization/departments/'
    | '/$slug/organization/external-contacts/'
    | '/$slug/organization/functions/'
    | '/$slug/organization/org-members/'
    | '/$slug/organization/systems/'
    | '/$slug/organization/teams/'
    | '/$slug/processes/all-processes/'
    | '/$slug/processes/create-processes/'
    | '/$slug/processes/editor/'
    | '/$slug/processes/process-chains/'
    | '/admin/accounts/$accountId/'
    | '/admin/tenants/$tenantId/'
    | '/$slug/processes/all-processes/$processId/flow-fullscreen'
    | '/$slug/processes/recording/start-recording/$processId'
    | '/$slug/processes/recording/step-recording/$recordingId'
    | '/$slug/help/tickets/$ticketId/'
    | '/$slug/processes/all-processes/$processId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  PartnerRoute: typeof PartnerRouteWithChildren
  SelectWorkspaceRoute: typeof SelectWorkspaceRoute
  VersionRoute: typeof VersionRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-workspace': {
      id: '/select-workspace'
      path: '/select-workspace'
      fullPath: '/select-workspace'
      preLoaderRoute: typeof SelectWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/version': {
      id: '/version'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug/': {
      id: '/$slug/'
      path: '/'
      fullPath: '/$slug/'
      preLoaderRoute: typeof SlugIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/apps': {
      id: '/$slug/apps'
      path: '/apps'
      fullPath: '/$slug/apps'
      preLoaderRoute: typeof SlugAppsRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/department': {
      id: '/$slug/department'
      path: '/department'
      fullPath: '/$slug/department'
      preLoaderRoute: typeof SlugDepartmentRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/initial-setup': {
      id: '/$slug/initial-setup'
      path: '/initial-setup'
      fullPath: '/$slug/initial-setup'
      preLoaderRoute: typeof SlugInitialSetupRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/my-tasks': {
      id: '/$slug/my-tasks'
      path: '/my-tasks'
      fullPath: '/$slug/my-tasks'
      preLoaderRoute: typeof SlugMyTasksRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/omniscient': {
      id: '/$slug/omniscient'
      path: '/omniscient'
      fullPath: '/$slug/omniscient'
      preLoaderRoute: typeof SlugOmniscientRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/organization': {
      id: '/$slug/organization'
      path: '/organization'
      fullPath: '/$slug/organization'
      preLoaderRoute: typeof SlugOrganizationRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/organization-settings': {
      id: '/$slug/organization-settings'
      path: '/organization-settings'
      fullPath: '/$slug/organization-settings'
      preLoaderRoute: typeof SlugOrganizationSettingsRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/seat-overrun': {
      id: '/$slug/seat-overrun'
      path: '/seat-overrun'
      fullPath: '/$slug/seat-overrun'
      preLoaderRoute: typeof SlugSeatOverrunRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/setup-pending': {
      id: '/$slug/setup-pending'
      path: '/setup-pending'
      fullPath: '/$slug/setup-pending'
      preLoaderRoute: typeof SlugSetupPendingRouteImport
      parentRoute: typeof SlugRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/': {
      id: '/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof PartnerIndexRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/partner/apps': {
      id: '/partner/apps'
      path: '/apps'
      fullPath: '/partner/apps'
      preLoaderRoute: typeof PartnerAppsRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/partner/tasks': {
      id: '/partner/tasks'
      path: '/tasks'
      fullPath: '/partner/tasks'
      preLoaderRoute: typeof PartnerTasksRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/$slug/apps/$': {
      id: '/$slug/apps/$'
      path: '/$'
      fullPath: '/$slug/apps/$'
      preLoaderRoute: typeof SlugAppsSplatRouteImport
      parentRoute: typeof SlugAppsRoute
    }
    '/$slug/artifacts/$artifactId': {
      id: '/$slug/artifacts/$artifactId'
      path: '/artifacts/$artifactId'
      fullPath: '/$slug/artifacts/$artifactId'
      preLoaderRoute: typeof SlugArtifactsArtifactIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/department/': {
      id: '/$slug/department/'
      path: '/'
      fullPath: '/$slug/department/'
      preLoaderRoute: typeof SlugDepartmentIndexRouteImport
      parentRoute: typeof SlugDepartmentRoute
    }
    '/$slug/department/members': {
      id: '/$slug/department/members'
      path: '/members'
      fullPath: '/$slug/department/members'
      preLoaderRoute: typeof SlugDepartmentMembersRouteImport
      parentRoute: typeof SlugDepartmentRoute
    }
    '/$slug/departments/$departmentId': {
      id: '/$slug/departments/$departmentId'
      path: '/departments/$departmentId'
      fullPath: '/$slug/departments/$departmentId'
      preLoaderRoute: typeof SlugDepartmentsDepartmentIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/external-contacts/$externalContactId': {
      id: '/$slug/external-contacts/$externalContactId'
      path: '/external-contacts/$externalContactId'
      fullPath: '/$slug/external-contacts/$externalContactId'
      preLoaderRoute: typeof SlugExternalContactsExternalContactIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/help/': {
      id: '/$slug/help/'
      path: '/help'
      fullPath: '/$slug/help/'
      preLoaderRoute: typeof SlugHelpIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/my-tasks/': {
      id: '/$slug/my-tasks/'
      path: '/'
      fullPath: '/$slug/my-tasks/'
      preLoaderRoute: typeof SlugMyTasksIndexRouteImport
      parentRoute: typeof SlugMyTasksRoute
    }
    '/$slug/omniscient/': {
      id: '/$slug/omniscient/'
      path: '/'
      fullPath: '/$slug/omniscient/'
      preLoaderRoute: typeof SlugOmniscientIndexRouteImport
      parentRoute: typeof SlugOmniscientRoute
    }
    '/$slug/omniscient/$sessionId': {
      id: '/$slug/omniscient/$sessionId'
      path: '/$sessionId'
      fullPath: '/$slug/omniscient/$sessionId'
      preLoaderRoute: typeof SlugOmniscientSessionIdRouteImport
      parentRoute: typeof SlugOmniscientRoute
    }
    '/$slug/org-functions/': {
      id: '/$slug/org-functions/'
      path: '/org-functions'
      fullPath: '/$slug/org-functions/'
      preLoaderRoute: typeof SlugOrgFunctionsIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/org-members/$orgMemberId': {
      id: '/$slug/org-members/$orgMemberId'
      path: '/org-members/$orgMemberId'
      fullPath: '/$slug/org-members/$orgMemberId'
      preLoaderRoute: typeof SlugOrgMembersOrgMemberIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/organigram/': {
      id: '/$slug/organigram/'
      path: '/organigram'
      fullPath: '/$slug/organigram/'
      preLoaderRoute: typeof SlugOrganigramIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/organization-settings/': {
      id: '/$slug/organization-settings/'
      path: '/'
      fullPath: '/$slug/organization-settings/'
      preLoaderRoute: typeof SlugOrganizationSettingsIndexRouteImport
      parentRoute: typeof SlugOrganizationSettingsRoute
    }
    '/$slug/organization-settings/apps': {
      id: '/$slug/organization-settings/apps'
      path: '/apps'
      fullPath: '/$slug/organization-settings/apps'
      preLoaderRoute: typeof SlugOrganizationSettingsAppsRouteImport
      parentRoute: typeof SlugOrganizationSettingsRoute
    }
    '/$slug/organization-settings/data-sync': {
      id: '/$slug/organization-settings/data-sync'
      path: '/data-sync'
      fullPath: '/$slug/organization-settings/data-sync'
      preLoaderRoute: typeof SlugOrganizationSettingsDataSyncRouteImport
      parentRoute: typeof SlugOrganizationSettingsRoute
    }
    '/$slug/organization-settings/settings': {
      id: '/$slug/organization-settings/settings'
      path: '/settings'
      fullPath: '/$slug/organization-settings/settings'
      preLoaderRoute: typeof SlugOrganizationSettingsSettingsRouteImport
      parentRoute: typeof SlugOrganizationSettingsRoute
    }
    '/$slug/organization-settings/user-management': {
      id: '/$slug/organization-settings/user-management'
      path: '/user-management'
      fullPath: '/$slug/organization-settings/user-management'
      preLoaderRoute: typeof SlugOrganizationSettingsUserManagementRouteImport
      parentRoute: typeof SlugOrganizationSettingsRoute
    }
    '/$slug/organization/artifacts': {
      id: '/$slug/organization/artifacts'
      path: '/artifacts'
      fullPath: '/$slug/organization/artifacts'
      preLoaderRoute: typeof SlugOrganizationArtifactsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/departments': {
      id: '/$slug/organization/departments'
      path: '/departments'
      fullPath: '/$slug/organization/departments'
      preLoaderRoute: typeof SlugOrganizationDepartmentsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/external-contacts': {
      id: '/$slug/organization/external-contacts'
      path: '/external-contacts'
      fullPath: '/$slug/organization/external-contacts'
      preLoaderRoute: typeof SlugOrganizationExternalContactsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/functions': {
      id: '/$slug/organization/functions'
      path: '/functions'
      fullPath: '/$slug/organization/functions'
      preLoaderRoute: typeof SlugOrganizationFunctionsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/org-members': {
      id: '/$slug/organization/org-members'
      path: '/org-members'
      fullPath: '/$slug/organization/org-members'
      preLoaderRoute: typeof SlugOrganizationOrgMembersRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/systems': {
      id: '/$slug/organization/systems'
      path: '/systems'
      fullPath: '/$slug/organization/systems'
      preLoaderRoute: typeof SlugOrganizationSystemsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/organization/teams': {
      id: '/$slug/organization/teams'
      path: '/teams'
      fullPath: '/$slug/organization/teams'
      preLoaderRoute: typeof SlugOrganizationTeamsRouteImport
      parentRoute: typeof SlugOrganizationRoute
    }
    '/$slug/processes/all-processes': {
      id: '/$slug/processes/all-processes'
      path: '/processes/all-processes'
      fullPath: '/$slug/processes/all-processes'
      preLoaderRoute: typeof SlugProcessesAllProcessesRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/create-processes': {
      id: '/$slug/processes/create-processes'
      path: '/processes/create-processes'
      fullPath: '/$slug/processes/create-processes'
      preLoaderRoute: typeof SlugProcessesCreateProcessesRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/process-chains': {
      id: '/$slug/processes/process-chains'
      path: '/processes/process-chains'
      fullPath: '/$slug/processes/process-chains'
      preLoaderRoute: typeof SlugProcessesProcessChainsRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/process-map': {
      id: '/$slug/processes/process-map'
      path: '/processes/process-map'
      fullPath: '/$slug/processes/process-map'
      preLoaderRoute: typeof SlugProcessesProcessMapRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/recording-dashboard/': {
      id: '/$slug/recording-dashboard/'
      path: '/recording-dashboard'
      fullPath: '/$slug/recording-dashboard/'
      preLoaderRoute: typeof SlugRecordingDashboardIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/systems/': {
      id: '/$slug/systems/'
      path: '/systems'
      fullPath: '/$slug/systems/'
      preLoaderRoute: typeof SlugSystemsIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/systems/$systemId': {
      id: '/$slug/systems/$systemId'
      path: '/systems/$systemId'
      fullPath: '/$slug/systems/$systemId'
      preLoaderRoute: typeof SlugSystemsSystemIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/systems/landscape': {
      id: '/$slug/systems/landscape'
      path: '/systems/landscape'
      fullPath: '/$slug/systems/landscape'
      preLoaderRoute: typeof SlugSystemsLandscapeRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/systems/shadow-systems': {
      id: '/$slug/systems/shadow-systems'
      path: '/systems/shadow-systems'
      fullPath: '/$slug/systems/shadow-systems'
      preLoaderRoute: typeof SlugSystemsShadowSystemsRouteImport
      parentRoute: typeof SlugRoute
    }
    '/admin/accounts/': {
      id: '/admin/accounts/'
      path: '/accounts'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof AdminAccountsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-usage/': {
      id: '/admin/ai-usage/'
      path: '/ai-usage'
      fullPath: '/admin/ai-usage/'
      preLoaderRoute: typeof AdminAiUsageIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics/': {
      id: '/admin/analytics/'
      path: '/analytics'
      fullPath: '/admin/analytics/'
      preLoaderRoute: typeof AdminAnalyticsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-logs/': {
      id: '/admin/audit-logs/'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs/'
      preLoaderRoute: typeof AdminAuditLogsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/partner-content/': {
      id: '/admin/partner-content/'
      path: '/partner-content'
      fullPath: '/admin/partner-content/'
      preLoaderRoute: typeof AdminPartnerContentIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tenants/': {
      id: '/admin/tenants/'
      path: '/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminTenantsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/partner/apps/$': {
      id: '/partner/apps/$'
      path: '/$'
      fullPath: '/partner/apps/$'
      preLoaderRoute: typeof PartnerAppsSplatRouteImport
      parentRoute: typeof PartnerAppsRoute
    }
    '/partner/organization/': {
      id: '/partner/organization/'
      path: '/organization'
      fullPath: '/partner/organization/'
      preLoaderRoute: typeof PartnerOrganizationIndexRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/partner/organization/users': {
      id: '/partner/organization/users'
      path: '/organization/users'
      fullPath: '/partner/organization/users'
      preLoaderRoute: typeof PartnerOrganizationUsersRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/$slug/department/members/': {
      id: '/$slug/department/members/'
      path: '/'
      fullPath: '/$slug/department/members/'
      preLoaderRoute: typeof SlugDepartmentMembersIndexRouteImport
      parentRoute: typeof SlugDepartmentMembersRoute
    }
    '/$slug/department/teams/': {
      id: '/$slug/department/teams/'
      path: '/teams'
      fullPath: '/$slug/department/teams/'
      preLoaderRoute: typeof SlugDepartmentTeamsIndexRouteImport
      parentRoute: typeof SlugDepartmentRoute
    }
    '/$slug/help/tickets/': {
      id: '/$slug/help/tickets/'
      path: '/help/tickets'
      fullPath: '/$slug/help/tickets/'
      preLoaderRoute: typeof SlugHelpTicketsIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/organization/artifacts/': {
      id: '/$slug/organization/artifacts/'
      path: '/'
      fullPath: '/$slug/organization/artifacts/'
      preLoaderRoute: typeof SlugOrganizationArtifactsIndexRouteImport
      parentRoute: typeof SlugOrganizationArtifactsRoute
    }
    '/$slug/organization/artifacts/$artifactId': {
      id: '/$slug/organization/artifacts/$artifactId'
      path: '/$artifactId'
      fullPath: '/$slug/organization/artifacts/$artifactId'
      preLoaderRoute: typeof SlugOrganizationArtifactsArtifactIdRouteImport
      parentRoute: typeof SlugOrganizationArtifactsRoute
    }
    '/$slug/organization/departments/': {
      id: '/$slug/organization/departments/'
      path: '/'
      fullPath: '/$slug/organization/departments/'
      preLoaderRoute: typeof SlugOrganizationDepartmentsIndexRouteImport
      parentRoute: typeof SlugOrganizationDepartmentsRoute
    }
    '/$slug/organization/departments/$departmentId': {
      id: '/$slug/organization/departments/$departmentId'
      path: '/$departmentId'
      fullPath: '/$slug/organization/departments/$departmentId'
      preLoaderRoute: typeof SlugOrganizationDepartmentsDepartmentIdRouteImport
      parentRoute: typeof SlugOrganizationDepartmentsRoute
    }
    '/$slug/organization/departments/bulk-upload': {
      id: '/$slug/organization/departments/bulk-upload'
      path: '/bulk-upload'
      fullPath: '/$slug/organization/departments/bulk-upload'
      preLoaderRoute: typeof SlugOrganizationDepartmentsBulkUploadRouteImport
      parentRoute: typeof SlugOrganizationDepartmentsRoute
    }
    '/$slug/organization/external-contacts/': {
      id: '/$slug/organization/external-contacts/'
      path: '/'
      fullPath: '/$slug/organization/external-contacts/'
      preLoaderRoute: typeof SlugOrganizationExternalContactsIndexRouteImport
      parentRoute: typeof SlugOrganizationExternalContactsRoute
    }
    '/$slug/organization/external-contacts/$externalContactId': {
      id: '/$slug/organization/external-contacts/$externalContactId'
      path: '/$externalContactId'
      fullPath: '/$slug/organization/external-contacts/$externalContactId'
      preLoaderRoute: typeof SlugOrganizationExternalContactsExternalContactIdRouteImport
      parentRoute: typeof SlugOrganizationExternalContactsRoute
    }
    '/$slug/organization/functions/': {
      id: '/$slug/organization/functions/'
      path: '/'
      fullPath: '/$slug/organization/functions/'
      preLoaderRoute: typeof SlugOrganizationFunctionsIndexRouteImport
      parentRoute: typeof SlugOrganizationFunctionsRoute
    }
    '/$slug/organization/functions/$orgFunctionId': {
      id: '/$slug/organization/functions/$orgFunctionId'
      path: '/$orgFunctionId'
      fullPath: '/$slug/organization/functions/$orgFunctionId'
      preLoaderRoute: typeof SlugOrganizationFunctionsOrgFunctionIdRouteImport
      parentRoute: typeof SlugOrganizationFunctionsRoute
    }
    '/$slug/organization/org-members/': {
      id: '/$slug/organization/org-members/'
      path: '/'
      fullPath: '/$slug/organization/org-members/'
      preLoaderRoute: typeof SlugOrganizationOrgMembersIndexRouteImport
      parentRoute: typeof SlugOrganizationOrgMembersRoute
    }
    '/$slug/organization/org-members/$orgMemberId': {
      id: '/$slug/organization/org-members/$orgMemberId'
      path: '/$orgMemberId'
      fullPath: '/$slug/organization/org-members/$orgMemberId'
      preLoaderRoute: typeof SlugOrganizationOrgMembersOrgMemberIdRouteImport
      parentRoute: typeof SlugOrganizationOrgMembersRoute
    }
    '/$slug/organization/systems/': {
      id: '/$slug/organization/systems/'
      path: '/'
      fullPath: '/$slug/organization/systems/'
      preLoaderRoute: typeof SlugOrganizationSystemsIndexRouteImport
      parentRoute: typeof SlugOrganizationSystemsRoute
    }
    '/$slug/organization/systems/$systemId': {
      id: '/$slug/organization/systems/$systemId'
      path: '/$systemId'
      fullPath: '/$slug/organization/systems/$systemId'
      preLoaderRoute: typeof SlugOrganizationSystemsSystemIdRouteImport
      parentRoute: typeof SlugOrganizationSystemsRoute
    }
    '/$slug/organization/teams/': {
      id: '/$slug/organization/teams/'
      path: '/'
      fullPath: '/$slug/organization/teams/'
      preLoaderRoute: typeof SlugOrganizationTeamsIndexRouteImport
      parentRoute: typeof SlugOrganizationTeamsRoute
    }
    '/$slug/organization/teams/$orgFunctionId': {
      id: '/$slug/organization/teams/$orgFunctionId'
      path: '/$orgFunctionId'
      fullPath: '/$slug/organization/teams/$orgFunctionId'
      preLoaderRoute: typeof SlugOrganizationTeamsOrgFunctionIdRouteImport
      parentRoute: typeof SlugOrganizationTeamsRoute
    }
    '/$slug/processes/all-processes/': {
      id: '/$slug/processes/all-processes/'
      path: '/'
      fullPath: '/$slug/processes/all-processes/'
      preLoaderRoute: typeof SlugProcessesAllProcessesIndexRouteImport
      parentRoute: typeof SlugProcessesAllProcessesRoute
    }
    '/$slug/processes/all-processes/$processId': {
      id: '/$slug/processes/all-processes/$processId'
      path: '/$processId'
      fullPath: '/$slug/processes/all-processes/$processId'
      preLoaderRoute: typeof SlugProcessesAllProcessesProcessIdRouteImport
      parentRoute: typeof SlugProcessesAllProcessesRoute
    }
    '/$slug/processes/create-processes/': {
      id: '/$slug/processes/create-processes/'
      path: '/'
      fullPath: '/$slug/processes/create-processes/'
      preLoaderRoute: typeof SlugProcessesCreateProcessesIndexRouteImport
      parentRoute: typeof SlugProcessesCreateProcessesRoute
    }
    '/$slug/processes/editor/': {
      id: '/$slug/processes/editor/'
      path: '/processes/editor'
      fullPath: '/$slug/processes/editor/'
      preLoaderRoute: typeof SlugProcessesEditorIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/editor/$processId': {
      id: '/$slug/processes/editor/$processId'
      path: '/processes/editor/$processId'
      fullPath: '/$slug/processes/editor/$processId'
      preLoaderRoute: typeof SlugProcessesEditorProcessIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/process-chains/': {
      id: '/$slug/processes/process-chains/'
      path: '/'
      fullPath: '/$slug/processes/process-chains/'
      preLoaderRoute: typeof SlugProcessesProcessChainsIndexRouteImport
      parentRoute: typeof SlugProcessesProcessChainsRoute
    }
    '/$slug/processes/process-chains/$chainId': {
      id: '/$slug/processes/process-chains/$chainId'
      path: '/$chainId'
      fullPath: '/$slug/processes/process-chains/$chainId'
      preLoaderRoute: typeof SlugProcessesProcessChainsChainIdRouteImport
      parentRoute: typeof SlugProcessesProcessChainsRoute
    }
    '/admin/accounts/$accountId/': {
      id: '/admin/accounts/$accountId/'
      path: '/accounts/$accountId'
      fullPath: '/admin/accounts/$accountId/'
      preLoaderRoute: typeof AdminAccountsAccountIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tenants/$tenantId/': {
      id: '/admin/tenants/$tenantId/'
      path: '/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId/'
      preLoaderRoute: typeof AdminTenantsTenantIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/$slug/help/tickets/$ticketId/': {
      id: '/$slug/help/tickets/$ticketId/'
      path: '/help/tickets/$ticketId'
      fullPath: '/$slug/help/tickets/$ticketId/'
      preLoaderRoute: typeof SlugHelpTicketsTicketIdIndexRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/all-processes/$processId/': {
      id: '/$slug/processes/all-processes/$processId/'
      path: '/'
      fullPath: '/$slug/processes/all-processes/$processId/'
      preLoaderRoute: typeof SlugProcessesAllProcessesProcessIdIndexRouteImport
      parentRoute: typeof SlugProcessesAllProcessesProcessIdRoute
    }
    '/$slug/processes/all-processes/$processId/flow-fullscreen': {
      id: '/$slug/processes/all-processes/$processId/flow-fullscreen'
      path: '/flow-fullscreen'
      fullPath: '/$slug/processes/all-processes/$processId/flow-fullscreen'
      preLoaderRoute: typeof SlugProcessesAllProcessesProcessIdFlowFullscreenRouteImport
      parentRoute: typeof SlugProcessesAllProcessesProcessIdRoute
    }
    '/$slug/processes/recording/start-recording/$processId': {
      id: '/$slug/processes/recording/start-recording/$processId'
      path: '/processes/recording/start-recording/$processId'
      fullPath: '/$slug/processes/recording/start-recording/$processId'
      preLoaderRoute: typeof SlugProcessesRecordingStartRecordingProcessIdRouteImport
      parentRoute: typeof SlugRoute
    }
    '/$slug/processes/recording/step-recording/$recordingId': {
      id: '/$slug/processes/recording/step-recording/$recordingId'
      path: '/processes/recording/step-recording/$recordingId'
      fullPath: '/$slug/processes/recording/step-recording/$recordingId'
      preLoaderRoute: typeof SlugProcessesRecordingStepRecordingRecordingIdRouteImport
      parentRoute: typeof SlugRoute
    }
  }
}

interface SlugAppsRouteChildren {
  SlugAppsSplatRoute: typeof SlugAppsSplatRoute
}

const SlugAppsRouteChildren: SlugAppsRouteChildren = {
  SlugAppsSplatRoute: SlugAppsSplatRoute,
}

const SlugAppsRouteWithChildren = SlugAppsRoute._addFileChildren(
  SlugAppsRouteChildren,
)

interface SlugDepartmentMembersRouteChildren {
  SlugDepartmentMembersIndexRoute: typeof SlugDepartmentMembersIndexRoute
}

const SlugDepartmentMembersRouteChildren: SlugDepartmentMembersRouteChildren = {
  SlugDepartmentMembersIndexRoute: SlugDepartmentMembersIndexRoute,
}

const SlugDepartmentMembersRouteWithChildren =
  SlugDepartmentMembersRoute._addFileChildren(
    SlugDepartmentMembersRouteChildren,
  )

interface SlugDepartmentRouteChildren {
  SlugDepartmentMembersRoute: typeof SlugDepartmentMembersRouteWithChildren
  SlugDepartmentIndexRoute: typeof SlugDepartmentIndexRoute
  SlugDepartmentTeamsIndexRoute: typeof SlugDepartmentTeamsIndexRoute
}

const SlugDepartmentRouteChildren: SlugDepartmentRouteChildren = {
  SlugDepartmentMembersRoute: SlugDepartmentMembersRouteWithChildren,
  SlugDepartmentIndexRoute: SlugDepartmentIndexRoute,
  SlugDepartmentTeamsIndexRoute: SlugDepartmentTeamsIndexRoute,
}

const SlugDepartmentRouteWithChildren = SlugDepartmentRoute._addFileChildren(
  SlugDepartmentRouteChildren,
)

interface SlugMyTasksRouteChildren {
  SlugMyTasksIndexRoute: typeof SlugMyTasksIndexRoute
}

const SlugMyTasksRouteChildren: SlugMyTasksRouteChildren = {
  SlugMyTasksIndexRoute: SlugMyTasksIndexRoute,
}

const SlugMyTasksRouteWithChildren = SlugMyTasksRoute._addFileChildren(
  SlugMyTasksRouteChildren,
)

interface SlugOmniscientRouteChildren {
  SlugOmniscientSessionIdRoute: typeof SlugOmniscientSessionIdRoute
  SlugOmniscientIndexRoute: typeof SlugOmniscientIndexRoute
}

const SlugOmniscientRouteChildren: SlugOmniscientRouteChildren = {
  SlugOmniscientSessionIdRoute: SlugOmniscientSessionIdRoute,
  SlugOmniscientIndexRoute: SlugOmniscientIndexRoute,
}

const SlugOmniscientRouteWithChildren = SlugOmniscientRoute._addFileChildren(
  SlugOmniscientRouteChildren,
)

interface SlugOrganizationArtifactsRouteChildren {
  SlugOrganizationArtifactsArtifactIdRoute: typeof SlugOrganizationArtifactsArtifactIdRoute
  SlugOrganizationArtifactsIndexRoute: typeof SlugOrganizationArtifactsIndexRoute
}

const SlugOrganizationArtifactsRouteChildren: SlugOrganizationArtifactsRouteChildren =
  {
    SlugOrganizationArtifactsArtifactIdRoute:
      SlugOrganizationArtifactsArtifactIdRoute,
    SlugOrganizationArtifactsIndexRoute: SlugOrganizationArtifactsIndexRoute,
  }

const SlugOrganizationArtifactsRouteWithChildren =
  SlugOrganizationArtifactsRoute._addFileChildren(
    SlugOrganizationArtifactsRouteChildren,
  )

interface SlugOrganizationDepartmentsRouteChildren {
  SlugOrganizationDepartmentsDepartmentIdRoute: typeof SlugOrganizationDepartmentsDepartmentIdRoute
  SlugOrganizationDepartmentsBulkUploadRoute: typeof SlugOrganizationDepartmentsBulkUploadRoute
  SlugOrganizationDepartmentsIndexRoute: typeof SlugOrganizationDepartmentsIndexRoute
}

const SlugOrganizationDepartmentsRouteChildren: SlugOrganizationDepartmentsRouteChildren =
  {
    SlugOrganizationDepartmentsDepartmentIdRoute:
      SlugOrganizationDepartmentsDepartmentIdRoute,
    SlugOrganizationDepartmentsBulkUploadRoute:
      SlugOrganizationDepartmentsBulkUploadRoute,
    SlugOrganizationDepartmentsIndexRoute:
      SlugOrganizationDepartmentsIndexRoute,
  }

const SlugOrganizationDepartmentsRouteWithChildren =
  SlugOrganizationDepartmentsRoute._addFileChildren(
    SlugOrganizationDepartmentsRouteChildren,
  )

interface SlugOrganizationExternalContactsRouteChildren {
  SlugOrganizationExternalContactsExternalContactIdRoute: typeof SlugOrganizationExternalContactsExternalContactIdRoute
  SlugOrganizationExternalContactsIndexRoute: typeof SlugOrganizationExternalContactsIndexRoute
}

const SlugOrganizationExternalContactsRouteChildren: SlugOrganizationExternalContactsRouteChildren =
  {
    SlugOrganizationExternalContactsExternalContactIdRoute:
      SlugOrganizationExternalContactsExternalContactIdRoute,
    SlugOrganizationExternalContactsIndexRoute:
      SlugOrganizationExternalContactsIndexRoute,
  }

const SlugOrganizationExternalContactsRouteWithChildren =
  SlugOrganizationExternalContactsRoute._addFileChildren(
    SlugOrganizationExternalContactsRouteChildren,
  )

interface SlugOrganizationFunctionsRouteChildren {
  SlugOrganizationFunctionsOrgFunctionIdRoute: typeof SlugOrganizationFunctionsOrgFunctionIdRoute
  SlugOrganizationFunctionsIndexRoute: typeof SlugOrganizationFunctionsIndexRoute
}

const SlugOrganizationFunctionsRouteChildren: SlugOrganizationFunctionsRouteChildren =
  {
    SlugOrganizationFunctionsOrgFunctionIdRoute:
      SlugOrganizationFunctionsOrgFunctionIdRoute,
    SlugOrganizationFunctionsIndexRoute: SlugOrganizationFunctionsIndexRoute,
  }

const SlugOrganizationFunctionsRouteWithChildren =
  SlugOrganizationFunctionsRoute._addFileChildren(
    SlugOrganizationFunctionsRouteChildren,
  )

interface SlugOrganizationOrgMembersRouteChildren {
  SlugOrganizationOrgMembersOrgMemberIdRoute: typeof SlugOrganizationOrgMembersOrgMemberIdRoute
  SlugOrganizationOrgMembersIndexRoute: typeof SlugOrganizationOrgMembersIndexRoute
}

const SlugOrganizationOrgMembersRouteChildren: SlugOrganizationOrgMembersRouteChildren =
  {
    SlugOrganizationOrgMembersOrgMemberIdRoute:
      SlugOrganizationOrgMembersOrgMemberIdRoute,
    SlugOrganizationOrgMembersIndexRoute: SlugOrganizationOrgMembersIndexRoute,
  }

const SlugOrganizationOrgMembersRouteWithChildren =
  SlugOrganizationOrgMembersRoute._addFileChildren(
    SlugOrganizationOrgMembersRouteChildren,
  )

interface SlugOrganizationSystemsRouteChildren {
  SlugOrganizationSystemsSystemIdRoute: typeof SlugOrganizationSystemsSystemIdRoute
  SlugOrganizationSystemsIndexRoute: typeof SlugOrganizationSystemsIndexRoute
}

const SlugOrganizationSystemsRouteChildren: SlugOrganizationSystemsRouteChildren =
  {
    SlugOrganizationSystemsSystemIdRoute: SlugOrganizationSystemsSystemIdRoute,
    SlugOrganizationSystemsIndexRoute: SlugOrganizationSystemsIndexRoute,
  }

const SlugOrganizationSystemsRouteWithChildren =
  SlugOrganizationSystemsRoute._addFileChildren(
    SlugOrganizationSystemsRouteChildren,
  )

interface SlugOrganizationTeamsRouteChildren {
  SlugOrganizationTeamsOrgFunctionIdRoute: typeof SlugOrganizationTeamsOrgFunctionIdRoute
  SlugOrganizationTeamsIndexRoute: typeof SlugOrganizationTeamsIndexRoute
}

const SlugOrganizationTeamsRouteChildren: SlugOrganizationTeamsRouteChildren = {
  SlugOrganizationTeamsOrgFunctionIdRoute:
    SlugOrganizationTeamsOrgFunctionIdRoute,
  SlugOrganizationTeamsIndexRoute: SlugOrganizationTeamsIndexRoute,
}

const SlugOrganizationTeamsRouteWithChildren =
  SlugOrganizationTeamsRoute._addFileChildren(
    SlugOrganizationTeamsRouteChildren,
  )

interface SlugOrganizationRouteChildren {
  SlugOrganizationArtifactsRoute: typeof SlugOrganizationArtifactsRouteWithChildren
  SlugOrganizationDepartmentsRoute: typeof SlugOrganizationDepartmentsRouteWithChildren
  SlugOrganizationExternalContactsRoute: typeof SlugOrganizationExternalContactsRouteWithChildren
  SlugOrganizationFunctionsRoute: typeof SlugOrganizationFunctionsRouteWithChildren
  SlugOrganizationOrgMembersRoute: typeof SlugOrganizationOrgMembersRouteWithChildren
  SlugOrganizationSystemsRoute: typeof SlugOrganizationSystemsRouteWithChildren
  SlugOrganizationTeamsRoute: typeof SlugOrganizationTeamsRouteWithChildren
}

const SlugOrganizationRouteChildren: SlugOrganizationRouteChildren = {
  SlugOrganizationArtifactsRoute: SlugOrganizationArtifactsRouteWithChildren,
  SlugOrganizationDepartmentsRoute:
    SlugOrganizationDepartmentsRouteWithChildren,
  SlugOrganizationExternalContactsRoute:
    SlugOrganizationExternalContactsRouteWithChildren,
  SlugOrganizationFunctionsRoute: SlugOrganizationFunctionsRouteWithChildren,
  SlugOrganizationOrgMembersRoute: SlugOrganizationOrgMembersRouteWithChildren,
  SlugOrganizationSystemsRoute: SlugOrganizationSystemsRouteWithChildren,
  SlugOrganizationTeamsRoute: SlugOrganizationTeamsRouteWithChildren,
}

const SlugOrganizationRouteWithChildren =
  SlugOrganizationRoute._addFileChildren(SlugOrganizationRouteChildren)

interface SlugOrganizationSettingsRouteChildren {
  SlugOrganizationSettingsAppsRoute: typeof SlugOrganizationSettingsAppsRoute
  SlugOrganizationSettingsDataSyncRoute: typeof SlugOrganizationSettingsDataSyncRoute
  SlugOrganizationSettingsSettingsRoute: typeof SlugOrganizationSettingsSettingsRoute
  SlugOrganizationSettingsUserManagementRoute: typeof SlugOrganizationSettingsUserManagementRoute
  SlugOrganizationSettingsIndexRoute: typeof SlugOrganizationSettingsIndexRoute
}

const SlugOrganizationSettingsRouteChildren: SlugOrganizationSettingsRouteChildren =
  {
    SlugOrganizationSettingsAppsRoute: SlugOrganizationSettingsAppsRoute,
    SlugOrganizationSettingsDataSyncRoute:
      SlugOrganizationSettingsDataSyncRoute,
    SlugOrganizationSettingsSettingsRoute:
      SlugOrganizationSettingsSettingsRoute,
    SlugOrganizationSettingsUserManagementRoute:
      SlugOrganizationSettingsUserManagementRoute,
    SlugOrganizationSettingsIndexRoute: SlugOrganizationSettingsIndexRoute,
  }

const SlugOrganizationSettingsRouteWithChildren =
  SlugOrganizationSettingsRoute._addFileChildren(
    SlugOrganizationSettingsRouteChildren,
  )

interface SlugProcessesAllProcessesProcessIdRouteChildren {
  SlugProcessesAllProcessesProcessIdFlowFullscreenRoute: typeof SlugProcessesAllProcessesProcessIdFlowFullscreenRoute
  SlugProcessesAllProcessesProcessIdIndexRoute: typeof SlugProcessesAllProcessesProcessIdIndexRoute
}

const SlugProcessesAllProcessesProcessIdRouteChildren: SlugProcessesAllProcessesProcessIdRouteChildren =
  {
    SlugProcessesAllProcessesProcessIdFlowFullscreenRoute:
      SlugProcessesAllProcessesProcessIdFlowFullscreenRoute,
    SlugProcessesAllProcessesProcessIdIndexRoute:
      SlugProcessesAllProcessesProcessIdIndexRoute,
  }

const SlugProcessesAllProcessesProcessIdRouteWithChildren =
  SlugProcessesAllProcessesProcessIdRoute._addFileChildren(
    SlugProcessesAllProcessesProcessIdRouteChildren,
  )

interface SlugProcessesAllProcessesRouteChildren {
  SlugProcessesAllProcessesProcessIdRoute: typeof SlugProcessesAllProcessesProcessIdRouteWithChildren
  SlugProcessesAllProcessesIndexRoute: typeof SlugProcessesAllProcessesIndexRoute
}

const SlugProcessesAllProcessesRouteChildren: SlugProcessesAllProcessesRouteChildren =
  {
    SlugProcessesAllProcessesProcessIdRoute:
      SlugProcessesAllProcessesProcessIdRouteWithChildren,
    SlugProcessesAllProcessesIndexRoute: SlugProcessesAllProcessesIndexRoute,
  }

const SlugProcessesAllProcessesRouteWithChildren =
  SlugProcessesAllProcessesRoute._addFileChildren(
    SlugProcessesAllProcessesRouteChildren,
  )

interface SlugProcessesCreateProcessesRouteChildren {
  SlugProcessesCreateProcessesIndexRoute: typeof SlugProcessesCreateProcessesIndexRoute
}

const SlugProcessesCreateProcessesRouteChildren: SlugProcessesCreateProcessesRouteChildren =
  {
    SlugProcessesCreateProcessesIndexRoute:
      SlugProcessesCreateProcessesIndexRoute,
  }

const SlugProcessesCreateProcessesRouteWithChildren =
  SlugProcessesCreateProcessesRoute._addFileChildren(
    SlugProcessesCreateProcessesRouteChildren,
  )

interface SlugProcessesProcessChainsRouteChildren {
  SlugProcessesProcessChainsChainIdRoute: typeof SlugProcessesProcessChainsChainIdRoute
  SlugProcessesProcessChainsIndexRoute: typeof SlugProcessesProcessChainsIndexRoute
}

const SlugProcessesProcessChainsRouteChildren: SlugProcessesProcessChainsRouteChildren =
  {
    SlugProcessesProcessChainsChainIdRoute:
      SlugProcessesProcessChainsChainIdRoute,
    SlugProcessesProcessChainsIndexRoute: SlugProcessesProcessChainsIndexRoute,
  }

const SlugProcessesProcessChainsRouteWithChildren =
  SlugProcessesProcessChainsRoute._addFileChildren(
    SlugProcessesProcessChainsRouteChildren,
  )

interface SlugRouteChildren {
  SlugAppsRoute: typeof SlugAppsRouteWithChildren
  SlugDepartmentRoute: typeof SlugDepartmentRouteWithChildren
  SlugInitialSetupRoute: typeof SlugInitialSetupRoute
  SlugMyTasksRoute: typeof SlugMyTasksRouteWithChildren
  SlugOmniscientRoute: typeof SlugOmniscientRouteWithChildren
  SlugOrganizationRoute: typeof SlugOrganizationRouteWithChildren
  SlugOrganizationSettingsRoute: typeof SlugOrganizationSettingsRouteWithChildren
  SlugSeatOverrunRoute: typeof SlugSeatOverrunRoute
  SlugSetupPendingRoute: typeof SlugSetupPendingRoute
  SlugIndexRoute: typeof SlugIndexRoute
  SlugArtifactsArtifactIdRoute: typeof SlugArtifactsArtifactIdRoute
  SlugDepartmentsDepartmentIdRoute: typeof SlugDepartmentsDepartmentIdRoute
  SlugExternalContactsExternalContactIdRoute: typeof SlugExternalContactsExternalContactIdRoute
  SlugOrgMembersOrgMemberIdRoute: typeof SlugOrgMembersOrgMemberIdRoute
  SlugProcessesAllProcessesRoute: typeof SlugProcessesAllProcessesRouteWithChildren
  SlugProcessesCreateProcessesRoute: typeof SlugProcessesCreateProcessesRouteWithChildren
  SlugProcessesProcessChainsRoute: typeof SlugProcessesProcessChainsRouteWithChildren
  SlugProcessesProcessMapRoute: typeof SlugProcessesProcessMapRoute
  SlugSystemsSystemIdRoute: typeof SlugSystemsSystemIdRoute
  SlugSystemsLandscapeRoute: typeof SlugSystemsLandscapeRoute
  SlugSystemsShadowSystemsRoute: typeof SlugSystemsShadowSystemsRoute
  SlugHelpIndexRoute: typeof SlugHelpIndexRoute
  SlugOrgFunctionsIndexRoute: typeof SlugOrgFunctionsIndexRoute
  SlugOrganigramIndexRoute: typeof SlugOrganigramIndexRoute
  SlugRecordingDashboardIndexRoute: typeof SlugRecordingDashboardIndexRoute
  SlugSystemsIndexRoute: typeof SlugSystemsIndexRoute
  SlugProcessesEditorProcessIdRoute: typeof SlugProcessesEditorProcessIdRoute
  SlugHelpTicketsIndexRoute: typeof SlugHelpTicketsIndexRoute
  SlugProcessesEditorIndexRoute: typeof SlugProcessesEditorIndexRoute
  SlugProcessesRecordingStartRecordingProcessIdRoute: typeof SlugProcessesRecordingStartRecordingProcessIdRoute
  SlugProcessesRecordingStepRecordingRecordingIdRoute: typeof SlugProcessesRecordingStepRecordingRecordingIdRoute
  SlugHelpTicketsTicketIdIndexRoute: typeof SlugHelpTicketsTicketIdIndexRoute
}

const SlugRouteChildren: SlugRouteChildren = {
  SlugAppsRoute: SlugAppsRouteWithChildren,
  SlugDepartmentRoute: SlugDepartmentRouteWithChildren,
  SlugInitialSetupRoute: SlugInitialSetupRoute,
  SlugMyTasksRoute: SlugMyTasksRouteWithChildren,
  SlugOmniscientRoute: SlugOmniscientRouteWithChildren,
  SlugOrganizationRoute: SlugOrganizationRouteWithChildren,
  SlugOrganizationSettingsRoute: SlugOrganizationSettingsRouteWithChildren,
  SlugSeatOverrunRoute: SlugSeatOverrunRoute,
  SlugSetupPendingRoute: SlugSetupPendingRoute,
  SlugIndexRoute: SlugIndexRoute,
  SlugArtifactsArtifactIdRoute: SlugArtifactsArtifactIdRoute,
  SlugDepartmentsDepartmentIdRoute: SlugDepartmentsDepartmentIdRoute,
  SlugExternalContactsExternalContactIdRoute:
    SlugExternalContactsExternalContactIdRoute,
  SlugOrgMembersOrgMemberIdRoute: SlugOrgMembersOrgMemberIdRoute,
  SlugProcessesAllProcessesRoute: SlugProcessesAllProcessesRouteWithChildren,
  SlugProcessesCreateProcessesRoute:
    SlugProcessesCreateProcessesRouteWithChildren,
  SlugProcessesProcessChainsRoute: SlugProcessesProcessChainsRouteWithChildren,
  SlugProcessesProcessMapRoute: SlugProcessesProcessMapRoute,
  SlugSystemsSystemIdRoute: SlugSystemsSystemIdRoute,
  SlugSystemsLandscapeRoute: SlugSystemsLandscapeRoute,
  SlugSystemsShadowSystemsRoute: SlugSystemsShadowSystemsRoute,
  SlugHelpIndexRoute: SlugHelpIndexRoute,
  SlugOrgFunctionsIndexRoute: SlugOrgFunctionsIndexRoute,
  SlugOrganigramIndexRoute: SlugOrganigramIndexRoute,
  SlugRecordingDashboardIndexRoute: SlugRecordingDashboardIndexRoute,
  SlugSystemsIndexRoute: SlugSystemsIndexRoute,
  SlugProcessesEditorProcessIdRoute: SlugProcessesEditorProcessIdRoute,
  SlugHelpTicketsIndexRoute: SlugHelpTicketsIndexRoute,
  SlugProcessesEditorIndexRoute: SlugProcessesEditorIndexRoute,
  SlugProcessesRecordingStartRecordingProcessIdRoute:
    SlugProcessesRecordingStartRecordingProcessIdRoute,
  SlugProcessesRecordingStepRecordingRecordingIdRoute:
    SlugProcessesRecordingStepRecordingRecordingIdRoute,
  SlugHelpTicketsTicketIdIndexRoute: SlugHelpTicketsTicketIdIndexRoute,
}

const SlugRouteWithChildren = SlugRoute._addFileChildren(SlugRouteChildren)

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAccountsIndexRoute: typeof AdminAccountsIndexRoute
  AdminAiUsageIndexRoute: typeof AdminAiUsageIndexRoute
  AdminAnalyticsIndexRoute: typeof AdminAnalyticsIndexRoute
  AdminAuditLogsIndexRoute: typeof AdminAuditLogsIndexRoute
  AdminPartnerContentIndexRoute: typeof AdminPartnerContentIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminAccountsAccountIdIndexRoute: typeof AdminAccountsAccountIdIndexRoute
  AdminTenantsTenantIdIndexRoute: typeof AdminTenantsTenantIdIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminAccountsIndexRoute: AdminAccountsIndexRoute,
  AdminAiUsageIndexRoute: AdminAiUsageIndexRoute,
  AdminAnalyticsIndexRoute: AdminAnalyticsIndexRoute,
  AdminAuditLogsIndexRoute: AdminAuditLogsIndexRoute,
  AdminPartnerContentIndexRoute: AdminPartnerContentIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminAccountsAccountIdIndexRoute: AdminAccountsAccountIdIndexRoute,
  AdminTenantsTenantIdIndexRoute: AdminTenantsTenantIdIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface PartnerAppsRouteChildren {
  PartnerAppsSplatRoute: typeof PartnerAppsSplatRoute
}

const PartnerAppsRouteChildren: PartnerAppsRouteChildren = {
  PartnerAppsSplatRoute: PartnerAppsSplatRoute,
}

const PartnerAppsRouteWithChildren = PartnerAppsRoute._addFileChildren(
  PartnerAppsRouteChildren,
)

interface PartnerRouteChildren {
  PartnerAppsRoute: typeof PartnerAppsRouteWithChildren
  PartnerTasksRoute: typeof PartnerTasksRoute
  PartnerIndexRoute: typeof PartnerIndexRoute
  PartnerOrganizationUsersRoute: typeof PartnerOrganizationUsersRoute
  PartnerOrganizationIndexRoute: typeof PartnerOrganizationIndexRoute
}

const PartnerRouteChildren: PartnerRouteChildren = {
  PartnerAppsRoute: PartnerAppsRouteWithChildren,
  PartnerTasksRoute: PartnerTasksRoute,
  PartnerIndexRoute: PartnerIndexRoute,
  PartnerOrganizationUsersRoute: PartnerOrganizationUsersRoute,
  PartnerOrganizationIndexRoute: PartnerOrganizationIndexRoute,
}

const PartnerRouteWithChildren =
  PartnerRoute._addFileChildren(PartnerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  PartnerRoute: PartnerRouteWithChildren,
  SelectWorkspaceRoute: SelectWorkspaceRoute,
  VersionRoute: VersionRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
